(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["i-ching"] && !Shopify.designMode) return;
  try {
    
  // The JavaScript logic remains exactly the same as your original code.
  // It targets classes like .divination-section, #tab-electronic, etc. which are preserved in the HTML above.
  
  console.log('Zen Divination script starting...');

  window.divinationApp = {
    hexagramData: typeof window.allHexagramData !== 'undefined' ? window.allHexagramData : {},
    lineNames: ["Line 1 (Bottom)", "Line 2", "Line 3", "Line 4", "Line 5", "Line 6 (Top)"],
    
    init: function() {
        this.cacheDom();
        this.bindEvents();
        this.generateManualInputs();
        this.switchMode('electronic');
    },
    
    cacheDom: function() {
        this.root = document.querySelector('.divination-section');
        if (!this.root) return;
        this.tabElectronic = this.root.querySelector('#tab-electronic');
        this.tabManual = this.root.querySelector('#tab-manual');
        this.electronicDiv = this.root.querySelector('#electronic-divination');
        this.manualDiv = this.root.querySelector('#manual-divination');
        this.startElectronicBtn = this.root.querySelector('#start-electronic-button');
        this.electronicResultsDisplay = this.root.querySelector('#electronic-results-display');
        this.manualInputGrid = this.root.querySelector('.manual-input-grid');
        this.getResultBtn = this.root.querySelector('#get-result-button');
        this.resultsSection = this.root.querySelector('#results-section');
    },

    bindEvents: function() {
        if (!this.startElectronicBtn) return;
        try { if (this.currentMode === 'electronic') { this.electronicResults = this.electronicResults || []; this._setCastButton(); } } catch(e){}
        try { this._setHint('initial'); this._localizeMindset(); } catch(e){}
        const self = this;
        this.tabElectronic.addEventListener('click', () => self.switchMode('electronic'));
        this.tabManual.addEventListener('click', () => self.switchMode('manual'));
        this.startElectronicBtn.addEventListener('click', this.performElectronicDivination.bind(this));
        this.getResultBtn.addEventListener('click', this.handleGetResult.bind(this));
    },
    
    switchMode: function(mode) {
        this.currentMode = mode;
        this.tabElectronic.classList.toggle('active', mode === 'electronic');
        this.tabManual.classList.toggle('active', mode !== 'electronic');
        this.electronicDiv.style.display = mode === 'electronic' ? 'block' : 'none';
        this.manualDiv.style.display = mode !== 'electronic' ? 'block' : 'none';
        this.checkShowResultButton();
        if(this.resultsSection) this.resultsSection.style.display = 'none';
    },
    
    generateManualInputs: function() {
        if (!this.manualInputGrid) return;
        this.manualInputGrid.innerHTML = '';
        const lineLabels = ["Bottom", "Second", "Third", "Fourth", "Fifth", "Top"];
        for (let i = 5; i >= 0; i--) {
            // Structure kept compatible with CSS styling
            const row = `<div class="manual-input-row" data-line="${i}"><div class="yao-label">${lineLabels[i]} Line</div><div class="radio-group"><label><input type="radio" name="line-${i}" value="9"><span>Changing Yang ⚊</span></label><label><input type="radio" name="line-${i}" value="7" checked><span>Stable Yang ⚊</span></label><label><input type="radio" name="line-${i}" value="8"><span>Stable Yin ⚋</span></label><label><input type="radio" name="line-${i}" value="6"><span>Changing Yin ⚋</span></label></div></div>`;
            this.manualInputGrid.insertAdjacentHTML('beforeend', row);
        }
        this.manualInputGrid.querySelectorAll('input[type="radio"]').forEach(radio => radio.addEventListener('change', this.checkShowResultButton.bind(this)));
    },
    
    checkShowResultButton: function() {
        const show = (this.currentMode === 'electronic' && this.electronicResults && this.electronicResults.length === 6) || this.currentMode === 'manual';
        if(this.getResultBtn) this.getResultBtn.style.display = show ? 'inline-block' : 'none';
    },

    // ---- 六爻式摇卦:每点一下摇一爻,自下而上(2026-07-22) ----
    _localizeMindset: function() {
        var loc = window.QF_ICH_LOC;
        var M = {
          'en': ['Preparing your mind','The hexagram captures this moment. For the truest cast:','Settle your mind; take a few slow breaths.','Hold only your question in your thoughts.','Cast each of the six lines, one by one, from the bottom up.'],
          'zh-cn': ['静心','卦象映照此刻。求卦最准,宜:','静下心来,缓缓深呼吸几次。','心中只存你要问的那件事。','自下而上,一爻一爻地摇满六爻。'],
          'zh-tw': ['靜心','卦象映照此刻。求卦最準,宜:','靜下心來,緩緩深呼吸幾次。','心中只存你要問的那件事。','自下而上,一爻一爻地搖滿六爻。'],
          'es': ['Prepara tu mente','El hexagrama capta este momento. Para la tirada más veraz:','Calma tu mente; respira lento unas veces.','Mantén en tu pensamiento solo tu pregunta.','Lanza las seis líneas una a una, de abajo arriba.'],
          'de': ['Sammle deinen Geist','Das Hexagramm erfasst diesen Moment. Für den wahrsten Wurf:','Beruhige deinen Geist; atme ein paar Mal langsam.','Halte nur deine Frage im Sinn.','Wirf die sechs Linien eine nach der anderen, von unten nach oben.'],
          'fr': ['Préparez votre esprit',"L'hexagramme saisit cet instant. Pour le tirage le plus juste :",'Apaisez votre esprit ; respirez lentement.','Ne gardez que votre question à l\'esprit.','Tirez les six traits un à un, de bas en haut.'],
          'nl': ['Bereid je geest voor','Het hexagram vangt dit moment. Voor de zuiverste worp:','Kalmeer je geest; adem een paar keer langzaam.','Houd alleen je vraag in gedachten.','Werp de zes lijnen één voor één, van onder naar boven.'],
          'it': ['Prepara la mente',"L'esagramma coglie questo momento. Per il lancio più autentico:",'Calma la mente; fai qualche respiro lento.','Tieni in mente solo la tua domanda.','Lancia le sei linee una a una, dal basso verso l\'alto.']
        };
        var a = M[loc] || M.en;
        var set = function(id, t){ var e=document.getElementById(id); if(e) e.textContent=t; };
        set('qf-mindset-title', a[0]); set('qf-mindset-intro', a[1]);
        set('qf-mindset-s1', a[2]); set('qf-mindset-s2', a[3]); set('qf-mindset-s3', a[4]);
    },

    _posNames: function() {
        var loc = window.QF_ICH_LOC, zh = (loc === 'zh-cn' || loc === 'zh-tw');
        if (zh) return ['初爻', '二爻', '三爻', '四爻', '五爻', '上爻'];
        return ['Line 1 (Initial)', 'Line 2 (Second)', 'Line 3 (Third)',
                'Line 4 (Fourth)', 'Line 5 (Fifth)', 'Line 6 (Top)'];
    },
    _yaoName: function(value) {
        var loc = window.QF_ICH_LOC, zh = (loc === 'zh-cn' || loc === 'zh-tw');
        var M = zh ? {9:'老阳 ⚊', 7:'少阳 ⚊', 8:'少阴 ⚋', 6:'老阴 ⚋'}
                   : {9:'Old Yang ⚊', 7:'Young Yang ⚊', 8:'Young Yin ⚋', 6:'Old Yin ⚋'};
        return M[value];
    },
    _hintText: function(state) {
        var loc = window.QF_ICH_LOC;
        var M = {
            'en':    {initial:'Focus on your question, then cast.', cont:'Continue with focused intention.', done:'The six lines are complete.'},
            'zh-cn': {initial:'心中默念你的问题,然后摇卦。', cont:'保持专注,继续摇下一爻。', done:'六爻已成。'},
            'zh-tw': {initial:'心中默念你的問題,然後搖卦。', cont:'保持專注,繼續搖下一爻。', done:'六爻已成。'},
            'es':    {initial:'Concéntrate en tu pregunta y lanza.', cont:'Continúa con intención concentrada.', done:'Las seis líneas están completas.'},
            'de':    {initial:'Konzentriere dich auf deine Frage und wirf.', cont:'Fahre mit gesammelter Absicht fort.', done:'Die sechs Linien sind vollständig.'},
            'fr':    {initial:'Concentrez-vous sur votre question, puis tirez.', cont:'Continuez avec une intention concentrée.', done:'Les six traits sont complets.'},
            'nl':    {initial:'Richt je op je vraag en werp.', cont:'Ga verder met gerichte aandacht.', done:'De zes lijnen zijn compleet.'},
            'it':    {initial:'Concentrati sulla tua domanda, poi lancia.', cont:'Continua con intenzione concentrata.', done:'Le sei linee sono complete.'}
        };
        return (M[loc] || M.en)[state];
    },
    _setHint: function(state) {
        var h = document.getElementById('qf-casting-hint');
        if (!h) return;
        h.textContent = this._hintText(state);
        h.classList.toggle('active', state !== 'initial');
    },

    _castLabels: function() {
        var M = {
            'en':    {first:'Toss for the first line', next:'Toss for line %n of 6', again:'Cast again', tossing:'Tossing…'},
            'zh-cn': {first:'摇第一爻', next:'摇第 %n 爻(共六爻)', again:'重新摇卦', tossing:'投掷中…'},
            'zh-tw': {first:'搖第一爻', next:'搖第 %n 爻(共六爻)', again:'重新搖卦', tossing:'投擲中…'},
            'es':    {first:'Lanzar la primera línea', next:'Lanzar la línea %n de 6', again:'Lanzar de nuevo', tossing:'Lanzando…'},
            'de':    {first:'Erste Linie werfen', next:'Linie %n von 6 werfen', again:'Erneut werfen', tossing:'Wird geworfen…'},
            'fr':    {first:'Tirer le premier trait', next:'Tirer le trait %n sur 6', again:'Tirer à nouveau', tossing:'Lancement…'},
            'nl':    {first:'Werp de eerste lijn', next:'Werp lijn %n van 6', again:'Opnieuw werpen', tossing:'Werpen…'},
            'it':    {first:'Lancia la prima linea', next:'Lancia la linea %n di 6', again:'Lancia di nuovo', tossing:'Lancio…'}
        };
        return M[window.QF_ICH_LOC] || M.en;
    },

    _lineRowLabel: function(idx, value) {
        var loc = window.QF_ICH_LOC;
        var zh = (loc === 'zh-cn' || loc === 'zh-tw');
        var names = zh ? ['初爻','二爻','三爻','四爻','五爻','上爻'] : this.lineNames;
        var vmap = zh
            ? {9:'老阳 ⚊»⚋', 7:'少阳 ⚊', 8:'少阴 ⚋', 6:'老阴 ⚋»⚊'}
            : {9:'Changing Yang (⚊ » ⚋)', 7:'Stable Yang (⚊)', 8:'Stable Yin (⚋)', 6:'Changing Yin (⚋ » ⚊)'};
        return names[idx] + ': ' + vmap[value];
    },

    _setCastButton: function(state) {
        var lab = this._castLabels();
        var n = this.electronicResults.length;
        var txt;
        if (state === 'tossing') { txt = lab.tossing; }
        else if (n >= 6) { txt = lab.again; }
        else if (n === 0) { txt = lab.first; }
        else { txt = lab.next.replace('%n', n + 1); }
        this.startElectronicBtn.innerHTML = '<span>' + txt + '</span>';
    },

    performElectronicDivination: function() {
        // 已摇满六爻 → 本次点击是"重新摇卦":清空重来,等下一次点击摇第一爻
        if (this.electronicResults && this.electronicResults.length >= 6) {
            this.electronicResults = [];
            this.electronicResultsDisplay.innerHTML = '';
            if (this.resultsSection) this.resultsSection.style.display = 'none';
            this._setCastButton();
            this._setHint('initial');
            this.checkShowResultButton();
            return;
        }
        if (!this.electronicResults) this.electronicResults = [];
        if (this._tossing) return;
        this._tossing = true;

        if (this.electronicResults.length === 0) {
            document.dispatchEvent(new CustomEvent('divination:start'));
        }
        this.startElectronicBtn.disabled = true;
        this.startElectronicBtn.classList.add('qf-casting');
        var _b = this.startElectronicBtn;
        setTimeout(function(){ _b.classList.remove('qf-casting'); }, 560);
        this._setCastButton('tossing');

        var self = this;
        setTimeout(function() {
            var valueMap = {3:9, 2:7, 1:8, 0:6};
            var heads = 0;
            for (var i = 0; i < 3; i++) { if (Math.random() < 0.5) heads++; }
            var value = valueMap[heads];
            var idx = self.electronicResults.length;
            self.electronicResults.push(value);

            var moving = (value === 9 || value === 6);
            var card = document.createElement('div');
            card.className = 'yao-result-item appear' + (moving ? ' moving' : '');
            var pos = document.createElement('span'); pos.className = 'position';
            pos.textContent = self._posNames()[idx];
            var res = document.createElement('span'); res.className = 'result';
            res.textContent = self._yaoName(value);
            card.appendChild(pos); card.appendChild(res);
            self.electronicResultsDisplay.appendChild(card);

            self._tossing = false;
            self.startElectronicBtn.disabled = false;

            if (self.electronicResults.length >= 6) {
                document.dispatchEvent(new CustomEvent('divination:stop'));
            }
            self._setCastButton();
            self._setHint(self.electronicResults.length >= 6 ? 'done' : 'cont');
            self.checkShowResultButton();
        }, 420);
    },
    
    getManualInputs: function() {
        const results = [];
        for (let i = 0; i < 6; i++) {
            const selectedRadio = this.root.querySelector(`input[name="line-${i}"]:checked`);
            if (!selectedRadio) return null;
            results.push(parseInt(selectedRadio.value, 10));
        }
        return results;
    },

    handleGetResult: function() {
        const linesArray = this.currentMode === 'electronic' ? this.electronicResults : this.getManualInputs();
        if(!this.hexagramData || Object.keys(this.hexagramData).length < 64) {
            alert('Hexagram data not fully loaded.');
            return;
        }
        if (linesArray && linesArray.length === 6) {
            this.calculateAndDisplayResult(linesArray);
        } else {
            alert('Please complete all six lines.');
        }
    },
    
    calculateAndDisplayResult: function(lines) {
        let originalKey = '', changedKey = '', changingLinesIdx = [];
        lines.forEach((val, index) => {
            if (val === 9) { originalKey += '1'; changedKey += '0'; changingLinesIdx.push(index); }
            else if (val === 7) { originalKey += '1'; changedKey += '1'; }
            else if (val === 6) { originalKey += '0'; changedKey += '1'; changingLinesIdx.push(index); }
            else if (val === 8) { originalKey += '0'; changedKey += '0'; }
        });

        const originalHex = this.hexagramData[originalKey];
        const changedHex = this.hexagramData[changedKey];
        
        if (!originalHex) return;

        this._populateHexagramOverviewCard('original', originalHex, changingLinesIdx);
        const changedHexDiv = this.root.querySelector('#changed-hexagram');
        if (changingLinesIdx.length > 0) {
            this._populateHexagramOverviewCard('changed', changedHex, []);
            changedHexDiv.style.display = 'block';
        } else {
            changedHexDiv.style.display = 'none';
        }
        
        this._generateFinalInterpretation(originalHex, changedHex, changingLinesIdx, originalKey);
        this._renderCastCode(lines);
        this._runAi(lines, originalHex, changedHex, changingLinesIdx, originalKey, changedKey);

        this.resultsSection.style.display = 'block';
        this.resultsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    
    // ===== 提问 / 卦码 / AI短解 / 邮箱门(2026-07-21) =====
    _castCode: null,
    _aiCtx: null,

    _zhuxiRule: function(n, oKey) {
        switch (n) {
            case 0: return "No changing lines - read the Judgment of the primary hexagram.";
            case 1: return "One changing line - read that line's text in the primary hexagram.";
            case 2: return "Two changing lines - read both line texts; the UPPER line prevails.";
            case 3: return "Three changing lines - read the Judgments of both primary and transformed hexagram; the PRIMARY prevails.";
            case 4: return "Four changing lines - read the two unchanged line texts of the TRANSFORMED hexagram; the LOWER prevails.";
            case 5: return "Five changing lines - read the single unchanged line text of the TRANSFORMED hexagram.";
            case 6: return (oKey === '111111' || oKey === '000000')
                ? "All six lines changing - read the special text (All Nines / All Sixes)."
                : "All six lines changing - read the Judgment of the TRANSFORMED hexagram.";
        }
        return "";
    },

    _renderCastCode: function(lines) {
        this._castCode = lines.join('');
        var T = window.QF_ICH_T(), el = document.getElementById('qf-castcode');
        if (!el) return;
        el.innerHTML = '<span class="qf-cc__label">' + T.codeLabel + '</span>'
            + '<code class="qf-cc__code">' + this._castCode + '</code>'
            + '<button type="button" class="qf-cc__btn" id="qf-cc-btn">' + T.copy + '</button>'
            + '<span class="qf-cc__hint">' + T.codeHint + '</span>';
        el.style.display = 'block';
        // 卦码随订单带到 Gumroad(只带 6 位数字,提问内容不进 URL)
        try {
            var pb = document.getElementById('qf-paid-btn');
            if (pb) {
                var base = pb.getAttribute('href').split('?')[0];
                pb.setAttribute('href', base + '?cast=' + this._castCode);
            }
            var pm = document.getElementById('qf-paid-micro');
            if (pm) pm.textContent = T.paidMicro.replace('{code}', this._castCode);
        } catch (e) {}
        var b = document.getElementById('qf-cc-btn'), self = this;
        b.addEventListener('click', function() {
            try { navigator.clipboard.writeText(self._castCode); } catch (e) {}
            b.textContent = T.copied;
            setTimeout(function() { b.textContent = T.copy; }, 1800);
        });
    },

    _buildFacts: function(oHex, cHex, idxs, oKey, cKey) {
        var n = idxs.length, A = [];
        A.push('PRIMARY HEXAGRAM: #' + this._binToNum[oKey] + ' ' + (oHex.name || '') + ' - ' + (oHex.english_name || ''));
        if (oHex.judgement) A.push('  Judgment: ' + oHex.judgement);
        if (oHex.judgement_meaning) A.push('  Judgment meaning: ' + oHex.judgement_meaning);
        if (oHex.image) A.push('  Image: ' + oHex.image);
        if (n > 0) {
            A.push('CHANGING LINES: ' + idxs.map(function(i) { return 'line ' + (i + 1); }).join(', '));
            idxs.forEach(function(i) {
                if (oHex.lines && oHex.lines[i]) A.push('  Line ' + (i + 1) + ' text: ' + oHex.lines[i]);
                if (oHex.lines_meaning && oHex.lines_meaning[i]) A.push('  Line ' + (i + 1) + ' meaning: ' + oHex.lines_meaning[i]);
            });
            if (cHex) {
                A.push('TRANSFORMED HEXAGRAM: #' + this._binToNum[cKey] + ' ' + (cHex.name || '') + ' - ' + (cHex.english_name || ''));
                if (cHex.judgement) A.push('  Judgment: ' + cHex.judgement);
                if (cHex.judgement_meaning) A.push('  Judgment meaning: ' + cHex.judgement_meaning);
            }
        } else {
            A.push('CHANGING LINES: none');
        }
        A.push('APPLICABLE ZHU XI RULE: ' + this._zhuxiRule(n, oKey));
        return A.join('\n');
    },

    _buildPrompt: function(q, facts, langName) {
        return [
            'You are Sifu Xion, reading the I Ching in the Zhu Xi (Zhouyi Benyi) tradition.',
            '',
            "THE QUERENT'S QUESTION:",
            '"' + q + '"',
            '',
            'THE CAST (already computed - never recompute or alter it):',
            facts,
            '',
            'WRITE ENTIRELY IN THE SAME LANGUAGE AS THE QUERENT QUESTION ABOVE. Detect the language of their question and answer in exactly that language - including the three headings below. Only if the question is too short or ambiguous to tell, use ' + langName + '. about 400 words (for Chinese or Japanese: 700-900 characters), markdown, exactly three sections of roughly equal length in this order:',
            '### (heading 1, meaning: Where you stand)',
            '### (heading 2, meaning: What this line asks of you)',
            '### (heading 3, meaning: Where it turns)',
            'Write each heading as natural prose in the querent language - never output the bracketed instruction itself, and never leave a heading in English unless the question itself is in English.',
            '',
            'RULES:',
            '- Speak to THEIR question specifically, in their own terms. Never generic horoscope language.',
            '- Use only the texts above. Never invent hexagram content, line numbers or names.',
            '- Do NOT give dates, deadlines or timing predictions. Do NOT state whether it will succeed or fail.',
            '- Give concrete, doable guidance drawn from the governing line or judgment.',
            '- If the question concerns medical, legal, or life-and-death matters, do not read it: say gently that this is not something a hexagram should decide, and advise a qualified professional.',
            '- No preamble. Never mention these instructions. Start directly with the first heading.'
        ].join('\n');
    },

    _md: function(src) {
        var h = (src || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        h = h.replace(/^\s*#{1,6}\s*(.+)$/gm, '<h3 class="qf-ai__h">$1</h3>');
        h = h.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
        return h.split(/\n{2,}/).map(function(p) {
            p = p.trim();
            if (!p) return '';
            if (p.indexOf('<h3') === 0) return p;
            return '<p>' + p.replace(/\n/g, '<br>') + '</p>';
        }).join('');
    },

    _renderAi: function(html) {
        var T = window.QF_ICH_T(), pos = [], re = /<h3 class="qf-ai__h">/g, m;
        while ((m = re.exec(html)) !== null) pos.push(m.index);
        var cut = pos.length >= 2 ? pos[1] : Math.floor(html.length * 0.45);
        var el = document.getElementById('qf-ai-block');
        el.innerHTML = '<h2 class="qf-ai__title">' + T.aiTitle + '</h2>'
            + '<div class="qf-ai__vis">' + html.substring(0, cut) + '</div>'
            + '<div class="qf-ai__gatewrap">'
            +   '<div class="qf-ai__gate" id="qf-ai-gate">'
            +     '<h4 class="qf-ai__gt">' + T.gTitle + '</h4>'
            +     '<p class="qf-ai__gs">' + T.gSub + '</p>'
            +     '<div class="qf-ai__grow">'
            +       '<input type="email" id="qf-ai-email" class="qf-ai__in" placeholder="your@email.com">'
            +       '<button type="button" id="qf-ai-unlock" class="qf-ai__gb">' + T.gBtn + '</button>'
            +     '</div>'
            +     '<p class="qf-ai__gp">' + T.gPriv + '</p><p class="qf-ai__gm" id="qf-ai-msg"></p>'
            +   '</div>'
            +   '<div class="qf-ai__hid" id="qf-ai-hid">' + html.substring(cut) + '</div>'
            + '</div>';
        el.style.display = 'block';
        var self = this;
        document.getElementById('qf-ai-unlock').addEventListener('click', function() { self._unlock(); });
        document.getElementById('qf-ai-email').addEventListener('keydown', function(ev) {
            if (ev.key === 'Enter') self._unlock();
        });
    },

    _unlock: function() {
        var T = window.QF_ICH_T();
        var inp = document.getElementById('qf-ai-email'), msg = document.getElementById('qf-ai-msg');
        var email = (inp.value || '').trim();
        if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
            msg.textContent = T.gBad; msg.style.color = '#BC2D2D'; return;
        }
        document.getElementById('qf-ai-gate').style.display = 'none';
        document.getElementById('qf-ai-hid').classList.add('qf-ai__hid--open');
        msg.textContent = T.gOk; msg.style.color = '#B8860B';
        try { if (window.dataLayer) dataLayer.push({ event: 'iching_email_submit' }); } catch (e) {}
        this._pushKlaviyo(email);
        this._pushShopify(email);
    },

    _pushKlaviyo: function(email) {
        var c = this._aiCtx || {};
        var props = {
            iching_question: c.question || '',
            iching_cast_code: this._castCode || '',
            iching_hexagram: c.hexLabel || '',
            iching_changed_hexagram: c.changedLabel || '',
            iching_changing_lines: c.changing || '',
            iching_rule: c.rule || '',
            iching_language: window.QF_ICH_LOC || 'en',
            iching_reading: (c.reading || '').substring(0, 40000),
            iching_source: 'I Ching Tool'
        };
        try {
            var g = localStorage.getItem('qf_gclid');
            if (g) {
                props.bazi_gclid = g;
                props.bazi_gclid_at = localStorage.getItem('qf_gclid_at') || new Date().toISOString();
            }
        } catch (e) {}
        var payload = { data: { type: 'subscription', attributes: {
            custom_source: 'I Ching Tool',
            profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } },
            relationships: { list: { data: { type: 'list', id: 'Sq3QjB' } } } } };
        try {
            var ifr = document.createElement('iframe');
            ifr.style.display = 'none';
            document.body.appendChild(ifr);
            var cleanFetch = ifr.contentWindow.fetch.bind(ifr.contentWindow);
            cleanFetch('https://a.klaviyo.com/client/subscriptions/?company_id=W9yRYZ', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
                body: JSON.stringify(payload)
            }).then(function(r) {
                console.log(r.ok || r.status === 202 ? 'Klaviyo: ok' : 'Klaviyo: ' + r.status);
            }).catch(function(e) {
                console.warn('Klaviyo error (non-blocking):', e.message);
            }).then(function() { try { document.body.removeChild(ifr); } catch (e) {} });
        } catch (e) { console.warn('Klaviyo error (non-blocking):', e.message); }
    },

    _pushShopify: function(email) {
        try {
            var ifr = document.createElement('iframe');
            ifr.style.display = 'none';
            document.body.appendChild(ifr);
            var cleanFetch = ifr.contentWindow.fetch.bind(ifr.contentWindow);
            var fd = new FormData();
            fd.append('form_type', 'customer');
            fd.append('utf8', '✓');
            fd.append('contact[email]', email);
            fd.append('contact[tags]', 'newsletter,iching_tool_unlock');
            cleanFetch('/contact', { method: 'POST', body: fd })
                .catch(function() {})
                .then(function() { try { document.body.removeChild(ifr); } catch (e) {} });
        } catch (e) {}
    },

    _runAi: function(lines, oHex, cHex, idxs, oKey, cKey) {
        var T = window.QF_ICH_T(), el = document.getElementById('qf-ai-block'), self = this;
        if (!el) return;
        var qEl = document.getElementById('qf-question');
        var q = qEl ? (qEl.value || '').trim() : '';
        if (!q) {
            el.style.display = 'block';
            el.innerHTML = '<div class="qf-ai__ask"><p class="qf-ai__askl">' + T.askLabel + '</p>'
                + '<div class="qf-ai__grow"><input type="text" id="qf-ai-q2" class="qf-ai__in" maxlength="180" placeholder="' + T.qPh + '">'
                + '<button type="button" id="qf-ai-q2b" class="qf-ai__gb">' + T.askBtn + '</button></div></div>';
            var go = function() {
                var val = (document.getElementById('qf-ai-q2').value || '').trim();
                if (!val) return;
                if (qEl) qEl.value = val;
                self._runAi(lines, oHex, cHex, idxs, oKey, cKey);
            };
            document.getElementById('qf-ai-q2b').addEventListener('click', go);
            document.getElementById('qf-ai-q2').addEventListener('keydown', function(ev) {
                if (ev.key === 'Enter') go();
            });
            return;
        }
        // 有提问 -> 答案就是第一眼要看到的东西,提到结果区最前面
        var wasVisible = this.resultsSection && this.resultsSection.style.display !== 'none';
        try {
            if (this.resultsSection && el.parentNode === this.resultsSection
                && this.resultsSection.firstElementChild !== el) {
                this.resultsSection.insertBefore(el, this.resultsSection.firstChild);
            }
        } catch (e) {}
        el.style.display = 'block';
        el.innerHTML = '<div class="qf-ai__loading">' + T.aiLoading + '</div>';
        // 摇卦当下由 calculateAndDisplayResult 统一滚动;摇完之后才补问的,单独滚过去
        if (wasVisible) { try { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {} }
        this._aiCtx = {
            question: q,
            hexLabel: '#' + this._binToNum[oKey] + ' ' + (oHex.name || '') + ' ' + (oHex.english_name || ''),
            changedLabel: (idxs.length && cHex) ? ('#' + this._binToNum[cKey] + ' ' + (cHex.name || '')) : '',
            changing: idxs.map(function(i) { return i + 1; }).join(','),
            rule: this._zhuxiRule(idxs.length, oKey),
            reading: ''
        };
        var prompt = this._buildPrompt(q, this._buildFacts(oHex, cHex, idxs, oKey, cKey), T.lang);
        fetch('https://central-ai-server.onrender.com/api/ask-ai', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ prompt: prompt })
        }).then(function(r) { return r.json(); }).then(function(j) {
            var txt = (j && j.response) || '';
            if (!txt) { el.innerHTML = '<div class="qf-ai__loading">' + T.aiErr + '</div>'; return; }
            self._aiCtx.reading = txt;
            self._renderAi(self._md(txt));
        }).catch(function(e) {
            console.warn('AI reading failed:', e.message);
            el.innerHTML = '<div class="qf-ai__loading">' + T.aiErr + '</div>';
        });
    },

    // --- 卦象页链接支持(2026-07-21):二进制键 -> King Wen 卦号 ---
    _binToNum: {"111111": 1, "000000": 2, "100010": 3, "010001": 4, "111010": 5, "010111": 6, "010000": 7, "000010": 8, "111011": 9, "110111": 10, "111000": 11, "000111": 12, "101111": 13, "111101": 14, "001000": 15, "000100": 16, "100110": 17, "011001": 18, "110000": 19, "000011": 20, "100101": 21, "101001": 22, "000001": 23, "100000": 24, "100111": 25, "111001": 26, "100001": 27, "011110": 28, "010010": 29, "101101": 30, "001110": 31, "011100": 32, "001111": 33, "111100": 34, "000101": 35, "101000": 36, "101011": 37, "110101": 38, "001010": 39, "010100": 40, "110001": 41, "100011": 42, "111110": 43, "011111": 44, "000110": 45, "011000": 46, "010110": 47, "011010": 48, "101110": 49, "011101": 50, "100100": 51, "001001": 52, "001011": 53, "110100": 54, "101100": 55, "001101": 56, "011011": 57, "110110": 58, "010011": 59, "110010": 60, "110011": 61, "001100": 62, "101010": 63, "010101": 64},
    _keyOf: function(hex) {
        if (!hex) return null;
        for (const k in window.allHexagramData) {
            if (window.allHexagramData[k] === hex) return k;
        }
        return null;
    },
    _hexNum: function(hex) {
        const k = this._keyOf(hex);
        return k ? (this._binToNum[k] || null) : null;
    },
    _hexLink: function(hex, lineIdx) {
        const n = this._hexNum(hex);
        if (!n) return '';
        const isLine = (typeof lineIdx === 'number' && lineIdx >= 0 && lineIdx <= 5);
        const root = (window.QF_ROOT || '/').replace(/\/$/, '');
        const url = isLine ? `${root}/pages/i-ching-hexagram-${n}-${lineIdx + 1}` : `${root}/pages/i-ching-hexagram-${n}`;
        const label = isLine ? `Read ${n}.${lineIdx + 1} in full` : `Hexagram ${n} in full`;
        return ` <a class="qf-hex-link" href="${url}">${label} &rarr;</a>`;
    },

    _populateHexagramOverviewCard: function(type, hexData, changingLinesIdx) {
        const cardDiv = this.root.querySelector(`#${type}-hexagram`);
        // Added styling hooks for new design
        let cardContent = `
            <h2>${type === 'original' ? 'Primary Hexagram' : 'Transformed Hexagram'}${window.divinationApp._hexLink(hexData)}</h2>
            <div class="symbol">${hexData.symbol}</div>
            <div class="name">${hexData.name} ${hexData.english_name ? `(${hexData.english_name})` : ''}</div>
            <div class="interpretation-title">The Judgment</div>
            <div class="judgement-overview">
                <div class="judgement-text">${hexData.judgement}</div>
                <div class="judgement-meaning">${hexData.judgement_meaning || ''}</div>
            </div>
            <div class="interpretation-title">The Six Lines</div>
            <div class="line-list">`;

        if (hexData.lines && Array.isArray(hexData.lines)) {
            hexData.lines.slice(0, 6).reverse().forEach((lineText, index) => {
                const lineIndex = 5 - index;
                const lineMeaning = hexData.lines_meaning?.[lineIndex] || '';
                const isChanging = changingLinesIdx.includes(lineIndex);
                cardContent += `
                    <div class="line ${isChanging ? 'changing' : ''}">
                        <div class="line-text">${this.lineNames[lineIndex]}: ${lineText}</div>
                        <div class="line-meaning">${lineMeaning}</div>
                    </div>`;
            });
        }
        
        cardContent += `</div>`;
        cardDiv.innerHTML = cardContent;
    },

    _createMainInterpretationBlock: function(title, hex, lineIndex = -1) {
        let block = `<h2>${title}${(lineIndex >= 0 && lineIndex <= 5) ? this._hexLink(hex, lineIndex) : ''}</h2>`;
        if (lineIndex !== -1) {
            block += `<div class="interpretation-block">
                          <div class="original-text">${this.lineNames[lineIndex]}: ${hex.lines[lineIndex]}</div>
                          <div class="meaning-text">${hex.lines_meaning?.[lineIndex] || ''}</div>
                      </div>`;
        } else {
            block += `<div class="interpretation-block">
                          <div class="original-text">${hex.judgement}</div>
                          <div class="meaning-text">${hex.judgement_meaning || ''}</div>
                      </div>`;
        }
        return block;
    },

    _createFortuneSection: function(hex) {
        if (!hex) return '';
        return `<div class="fortune-section">
                    <div class="fortune-title">Love</div>
                    <div class="fortune">${hex.love || '-'}</div>
                    <div class="fortune-title">Career</div>
                    <div class="fortune">${hex.career || '-'}</div>
                    <div class="fortune-title">Wealth</div>
                    <div class="fortune">${hex.wealth || '-'}</div>
                </div>`;
    },

    _generateFinalInterpretation: function(originalHex, changedHex, changingLinesIdx, originalKey) {
        const targetDiv = this.root.querySelector('#final-interpretation');
        let content = '';
        const numChanges = changingLinesIdx.length;
        // Logic remains identical to original
        switch (numChanges) {
          case 0: content = this._createMainInterpretationBlock('Reading is based on the Judgment of the Primary Hexagram', originalHex) + this._createFortuneSection(originalHex); break;
          case 1: content = this._createMainInterpretationBlock('Reading is based on the changing line', originalHex, changingLinesIdx[0]) + this._createFortuneSection(originalHex); break;
          case 2: const [idx1, idx2] = changingLinesIdx; content = `<h2>Reading based on two changing lines (Upper prevails)</h2>` + this._createMainInterpretationBlock(`Primary: ${this.lineNames[idx2]}`, originalHex, idx2) + this._createMainInterpretationBlock(`Secondary: ${this.lineNames[idx1]}`, originalHex, idx1) + this._createFortuneSection(originalHex); break;
          case 3: content = `<h2>Reading based on both Judgments</h2>` + (this._createMainInterpretationBlock('Situation (Primary): ' + originalHex.english_name, originalHex) + this._createFortuneSection(originalHex)) + (this._createMainInterpretationBlock('Development (Transformed): ' + changedHex.english_name, changedHex) + this._createFortuneSection(changedHex)); break;
          case 4: const nonChanging4 = [0, 1, 2, 3, 4, 5].filter(i => !changingLinesIdx.includes(i)); const [nc4_1, nc4_2] = nonChanging4; content = `<h2>Reading based on stable lines of Transformed Hexagram (Lower prevails)</h2>` + this._createMainInterpretationBlock(`Primary: ${this.lineNames[nc4_1]}`, changedHex, nc4_1) + this._createMainInterpretationBlock(`Secondary: ${this.lineNames[nc4_2]}`, changedHex, nc4_2) + this._createFortuneSection(changedHex); break;
          case 5: const nonChanging5 = [0, 1, 2, 3, 4, 5].filter(i => !changingLinesIdx.includes(i))[0]; content = this._createMainInterpretationBlock('Reading based on the single stable line of Transformed Hexagram', changedHex, nonChanging5) + this._createFortuneSection(changedHex); break;
          case 6: if ((originalKey === '111111' || originalKey === '000000') && originalHex.lines.length > 6) { const specialIndex = 6; const title = originalKey === '111111' ? 'Reading based on "All Nines"' : 'Reading based on "All Sixes"'; content = this._createMainInterpretationBlock(title, originalHex, specialIndex) + this._createFortuneSection(originalHex); } else { content = this._createMainInterpretationBlock('Reading based on Judgment of Transformed Hexagram', changedHex) + this._createFortuneSection(changedHex); } break;
        }
        targetDiv.innerHTML = content;
    }
  };

  function initializeDivinationApp() {
      const appInstance = document.querySelector('.divination-section');
      if (appInstance && !appInstance.hasAttribute('data-initialized')) {
          window.divinationApp.init();
          appInstance.setAttribute('data-initialized', 'true');
      }
  }

  document.addEventListener('DOMContentLoaded', initializeDivinationApp);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (section.querySelector('.divination-section')) {
      if(section.hasAttribute('data-initialized')) {
        section.removeAttribute('data-initialized');
      }
      initializeDivinationApp();
    }
  });
  document.addEventListener('shopify:section:reorder', initializeDivinationApp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meihua"] && !Shopify.designMode) return;
  try {
    
/* ===================== Mei Hua V3 ===================== */

/* ---- 静态数据 ---- */
const MH_GUA_DATA = {
  1:{name:'Qian (Heaven)',cn:'乾',element:'Metal',symbol:'☰',image:'Heaven, father, authority, the round, strength, leadership, the head, gold, Northwest'},
  2:{name:'Dui (Lake)',cn:'兑',element:'Metal',symbol:'☱',image:'Lake, youngest daughter, the mouth, speech, joy, pleasure, a flaw, West'},
  3:{name:'Li (Fire)',cn:'离',element:'Fire',symbol:'☲',image:'Fire, middle daughter, the eye, brightness, documents, beauty, separation, South'},
  4:{name:'Zhen (Thunder)',cn:'震',element:'Wood',symbol:'☳',image:'Thunder, eldest son, the dragon, movement, shock, the feet, sudden action, East'},
  5:{name:'Xun (Wind)',cn:'巽',element:'Wood',symbol:'☴',image:'Wind, eldest daughter, wood, entering, the thighs, indecision, trade, Southeast'},
  6:{name:'Kan (Water)',cn:'坎',element:'Water',symbol:'☵',image:'Water, middle son, a pit/trap, danger, wisdom, the ears, hardship, North'},
  7:{name:'Gen (Mountain)',cn:'艮',element:'Earth',symbol:'☶',image:'Mountain, youngest son, stillness, the hand, stopping, obstacle, paths, Northeast'},
  8:{name:'Kun (Earth)',cn:'坤',element:'Earth',symbol:'☷',image:'Earth, mother, the multitude, receptivity, the belly, cloth, frugality, Southwest'}
};
const MH_GUA_YAOS = { 1:[1,1,1],2:[1,1,0],3:[1,0,1],4:[1,0,0],5:[0,1,1],6:[0,1,0],7:[0,0,1],8:[0,0,0] };
const MH_WUXING = { 'Metal,Wood':'Clash','Wood,Earth':'Clash','Earth,Water':'Clash','Water,Fire':'Clash','Fire,Metal':'Clash','Metal,Water':'Birth','Water,Wood':'Birth','Wood,Fire':'Birth','Fire,Earth':'Birth','Earth,Metal':'Birth' };
const MH_ELEM_CN = { Metal:'金',Wood:'木',Water:'水',Fire:'火',Earth:'土' };
const MH_HEXAGRAMS = {
  '11':'Qian / The Creative','88':'Kun / The Receptive','68':'Bi / Holding Together','86':'Shi / The Army','48':'Yu / Enthusiasm','84':'Fu / Return','56':'Huan / Dispersion','65':'Jing / The Well','27':'Xian / Influence','72':'Sun / Decrease','31':'Da You / Great Possession','13':'Tong Ren / Fellowship','15':'Gou / Coming to Meet','51':'Xiao Chu / Taming Power of the Small','82':'Lin / Approach','28':'Cui / Gathering Together','71':'Da Chu / Great Taming','17':'Dun / Retreat','38':'Jin / Progress','83':'Ming Yi / Darkening of the Light','45':'Heng / Duration','54':'Yi / Increase','58':'Xun / The Gentle','24':'Sui / Following','42':'Gui Mei / The Marrying Maiden','81':'Tai / Peace','18':'Pi / Standstill','62':'Jie / Limitation','26':'Kun / Oppression','34':'Shi He / Biting Through','43':'Feng / Abundance','35':'Ding / The Cauldron','53':'Jia Ren / The Family','61':'Xu / Waiting','16':'Song / Conflict','78':'Bo / Splitting Apart','87':'Qian / Modesty','47':'Xiao Guo / Small Preponderance','74':'Yi / Nourishment','21':'Guai / Breakthrough','12':'Lu / Treading','63':'Ji Ji / After Completion','36':'Wei Ji / Before Completion','75':'Gu / Work on the Decayed','57':'Jian / Development','23':'Ge / Revolution','32':'Kui / Opposition','46':'Jie / Deliverance','64':'Zhun / Difficulty at the Beginning','76':'Meng / Youthful Folly','66':'Kan / The Abysmal','33':'Li / The Clinging','44':'Zhen / The Arousing','22':'Dui / The Joyous','77':'Gen / Keeping Still','55':'Feng','67':'Jian','41':'Wu Wang','14':'Da Zhuang','25':'Sheng','52':'Meng','37':'Jia Ren','73':'Bo'
};
/* 后天八卦方位 -> 卦号 */
const MH_DIR_ORDER = ['unsure','N','NE','E','SE','S','SW','W','NW'];
const MH_DIR_GUA = { N:6,NE:7,E:4,SE:5,S:3,SW:8,W:2,NW:1,unsure:0 };

const MH_REL_CN = { 'Same (Support)':'比和（同类相助）','Generates (Drains strength)':'体生用（泄耗体之气）','Generated by (Increases strength)':'用生体（得生助，吉）','Clashes (Conquers)':'体克用（我能制彼，主动）','Clashed by (Damaged)':'用克体（受克受损，不利）','Unknown':'关系不明' };
const MH_SEASON_CN = { 'Strongest (Wang)':'旺（当令最强）','Strong (Xiang)':'相（得生，较旺）','Weak (Xiu)':'休（偏弱）','Trapped (Qiu)':'囚（受制）','Dead (Si)':'死（最弱）' };

/* ---- 界面多语言 ---- */
const MH_LANG_AI = { 'en':'English','zh-cn':'Simplified Chinese','zh-tw':'Traditional Chinese','es':'Spanish','fr':'French','de':'German' };
const MH_UI = {
  'en': {
    langLabel:'Language', modeObserve:'Observation', modeTime:'Time', modeNumber:'Number / Symbol',
    observeGuide:'The moment your question arises, notice your surroundings. What first catches your attention \u2014 a sound, an object, a number, a color, a movement? That is your omen.',
    observeLabel:'What first caught your attention?', observePlaceholder:'e.g. a crow on a red sign, the number 7, a slammed door',
    observeDirLabel:'Roughly which direction was it? (optional)', observeNote:'The changing line is set automatically from the present hour.',
    timeGuide:'The hexagram is cast from the exact moment of your question \u2014 its year, month, day and hour.', timeNote:'Both trigrams and the changing line are derived from the present time. Just hold your question in mind.',
    numberGuide:'\u201CEverything is a number.\u201D Enter two things that resonate with you \u2014 numbers, words, or characters.',
    upperLabel:'Upper source (Heaven)', upperPlaceholder:'e.g. 7, Sky, A', lowerLabel:'Lower source (Earth)', lowerPlaceholder:'e.g. 3, Lake, B', numberNote:'The changing line is set automatically from the present hour.',
    questionPlaceholder:'Focus your mind. Type your specific question here\u2026', revealBtn:'Reveal the Reading',
    stepOracle:'The Oracle Speaks', stepChart:'Hexagram Analysis', masterName:'The Oracle', timeNoteLoading:'Reasoning and interpretation run in two passes. Please remain patient.',
    timestampLabel:'Time of Divination:', guaOriginal:'Original', guaNuclear:'Nuclear', guaTransformed:'Transformed',
    computing:'Casting the hexagram\u2026', stageFmt:'Stage {n} / 2',
    alertQuestion:'Please enter your question first.', alertObserve:'Please describe what you noticed around you.', alertNumber:'Please enter values in both fields.',
    stage1:['Casting and weighing the Ti-Yong relationship.','Reading the nuclear and changing hexagrams.'],
    stage2:['Composing the reading in your language.','Phrasing the guidance and next steps.'],
    dir:['Not sure','North','Northeast','East','Southeast','South','Southwest','West','Northwest'],
    tyMode:'Casting method', tySelf:'Self (Ti)', tyUse:'Other (Yong)', tyRelationNow:'Present relation', tyOutcome:'Outcome relation', tyStrength:'Self strength', tyMoving:'Changing line', omenLabel:'Observed omen',
    disTitle:'Divination Notice', disContent:'Mei Hua Yi Shu is an ancient art for reflection and guidance. While it offers perspective, <strong>please do not rely on divination alone</strong> for critical matters such as <span class="emphasis">health, financial or legal decisions</span>. Consult qualified professionals when it matters.'
  },
  'zh-cn': {
    langLabel:'语言', modeObserve:'观物起卦', modeTime:'时间起卦', modeNumber:'数字 / 象',
    observeGuide:'问题在心中浮起的那一刻，留意你周围——最先触动你的是什么？一个声音、一件物、一个数字、一种颜色、一个动作？那就是你的外应。',
    observeLabel:'此刻最先触动你的是什么？', observePlaceholder:'例如：红色招牌上的一只乌鸦、数字 7、一声关门',
    observeDirLabel:'它大致在你的哪个方位？（可选）', observeNote:'动爻按当前时辰自动确定。',
    timeGuide:'以你起念发问的此刻——年、月、日、时——起卦。', timeNote:'上下卦与动爻都由当前时间推出，心里默念问题即可。',
    numberGuide:'“万物皆数。”输入两个此刻与你共鸣的东西——数字、词或字。',
    upperLabel:'上卦之源（天）', upperPlaceholder:'例如 7、天、A', lowerLabel:'下卦之源（地）', lowerPlaceholder:'例如 3、泽、B', numberNote:'动爻按当前时辰自动确定。',
    questionPlaceholder:'静心。在此写下你具体的问题……', revealBtn:'起卦解读',
    stepOracle:'卦象解读', stepChart:'卦象分析', masterName:'梅花断', timeNoteLoading:'推理与解读分两步进行，请稍候。',
    timestampLabel:'起卦时间：', guaOriginal:'本卦', guaNuclear:'互卦', guaTransformed:'变卦',
    computing:'正在起卦……', stageFmt:'第 {n}/2 步',
    alertQuestion:'请先写下你的问题。', alertObserve:'请描述你周围最先注意到的事物。', alertNumber:'请在两个输入框都填入内容。',
    stage1:['起卦并权衡体用生克。','研读互卦与变卦。'],
    stage2:['正在用你的语言撰写解读。','组织建议与下一步。'],
    dir:['不确定','正北','东北','正东','东南','正南','西南','正西','西北'],
    tyMode:'起卦方式', tySelf:'体卦（自身）', tyUse:'用卦（对方/事）', tyRelationNow:'当前体用关系', tyOutcome:'结果关系', tyStrength:'体卦旺衰', tyMoving:'动爻', omenLabel:'外应所见',
    disTitle:'重要提示', disContent:'梅花易数是中国古老的预测术，仅供参考。<strong>请勿将其作为重大决策的唯一依据</strong>，尤其涉及<span class="emphasis">健康、财务或法律决定</span>时。事关重大请咨询专业人士。'
  },
  'zh-tw': {
    langLabel:'語言', modeObserve:'觀物起卦', modeTime:'時間起卦', modeNumber:'數字 / 象',
    observeGuide:'問題在心中浮起的那一刻，留意你周圍——最先觸動你的是什麼？一個聲音、一件物、一個數字、一種顏色、一個動作？那就是你的外應。',
    observeLabel:'此刻最先觸動你的是什麼？', observePlaceholder:'例如：紅色招牌上的一隻烏鴉、數字 7、一聲關門',
    observeDirLabel:'它大致在你的哪個方位？（可選）', observeNote:'動爻按當前時辰自動確定。',
    timeGuide:'以你起念發問的此刻——年、月、日、時——起卦。', timeNote:'上下卦與動爻都由當前時間推出，心裡默念問題即可。',
    numberGuide:'「萬物皆數。」輸入兩個此刻與你共鳴的東西——數字、詞或字。',
    upperLabel:'上卦之源（天）', upperPlaceholder:'例如 7、天、A', lowerLabel:'下卦之源（地）', lowerPlaceholder:'例如 3、澤、B', numberNote:'動爻按當前時辰自動確定。',
    questionPlaceholder:'靜心。在此寫下你具體的問題……', revealBtn:'起卦解讀',
    stepOracle:'卦象解讀', stepChart:'卦象分析', masterName:'梅花斷', timeNoteLoading:'推理與解讀分兩步進行，請稍候。',
    timestampLabel:'起卦時間：', guaOriginal:'本卦', guaNuclear:'互卦', guaTransformed:'變卦',
    computing:'正在起卦……', stageFmt:'第 {n}/2 步',
    alertQuestion:'請先寫下你的問題。', alertObserve:'請描述你周圍最先注意到的事物。', alertNumber:'請在兩個輸入框都填入內容。',
    stage1:['起卦並權衡體用生克。','研讀互卦與變卦。'],
    stage2:['正在用你的語言撰寫解讀。','組織建議與下一步。'],
    dir:['不確定','正北','東北','正東','東南','正南','西南','正西','西北'],
    tyMode:'起卦方式', tySelf:'體卦（自身）', tyUse:'用卦（對方/事）', tyRelationNow:'當前體用關係', tyOutcome:'結果關係', tyStrength:'體卦旺衰', tyMoving:'動爻', omenLabel:'外應所見',
    disTitle:'重要提示', disContent:'梅花易數是中國古老的預測術，僅供參考。<strong>請勿將其作為重大決策的唯一依據</strong>，尤其涉及<span class="emphasis">健康、財務或法律決定</span>時。事關重大請諮詢專業人士。'
  },
  'es': {
    langLabel:'Idioma', modeObserve:'Observación', modeTime:'Tiempo', modeNumber:'Número / Símbolo',
    observeGuide:'En el momento en que surge tu pregunta, observa tu entorno. ¿Qué llama primero tu atención: un sonido, un objeto, un número, un color, un movimiento? Ese es tu presagio.',
    observeLabel:'¿Qué llamó primero tu atención?', observePlaceholder:'ej. un cuervo en un letrero rojo, el número 7, un portazo',
    observeDirLabel:'¿En qué dirección estaba aproximadamente? (opcional)', observeNote:'La línea cambiante se fija automáticamente según la hora actual.',
    timeGuide:'El hexagrama se obtiene del momento exacto de tu pregunta: año, mes, día y hora.', timeNote:'Ambos trigramas y la línea cambiante derivan del momento presente. Solo mantén tu pregunta en mente.',
    numberGuide:'\u201CTodo es número.\u201D Introduce dos cosas que resuenen contigo: números, palabras o caracteres.',
    upperLabel:'Fuente superior (Cielo)', upperPlaceholder:'ej. 7, Cielo, A', lowerLabel:'Fuente inferior (Tierra)', lowerPlaceholder:'ej. 3, Lago, B', numberNote:'La línea cambiante se fija automáticamente según la hora actual.',
    questionPlaceholder:'Concéntrate. Escribe aquí tu pregunta concreta\u2026', revealBtn:'Revelar la lectura',
    stepOracle:'El oráculo habla', stepChart:'Análisis del hexagrama', masterName:'El Oráculo', timeNoteLoading:'El razonamiento y la interpretación se hacen en dos pasos. Ten paciencia.',
    timestampLabel:'Momento de la adivinación:', guaOriginal:'Original', guaNuclear:'Nuclear', guaTransformed:'Transformado',
    computing:'Obteniendo el hexagrama\u2026', stageFmt:'Etapa {n} / 2',
    alertQuestion:'Por favor, escribe tu pregunta primero.', alertObserve:'Por favor, describe lo que notaste a tu alrededor.', alertNumber:'Por favor, completa ambos campos.',
    stage1:['Obteniendo y sopesando la relación Ti-Yong.','Leyendo el hexagrama nuclear y el transformado.'],
    stage2:['Redactando la lectura en tu idioma.','Formulando la guía y los siguientes pasos.'],
    dir:['No sé','Norte','Noreste','Este','Sureste','Sur','Suroeste','Oeste','Noroeste'],
    tyMode:'Método', tySelf:'Yo (Ti)', tyUse:'Otro (Yong)', tyRelationNow:'Relación actual', tyOutcome:'Relación del resultado', tyStrength:'Fuerza del Yo', tyMoving:'Línea cambiante', omenLabel:'Presagio observado',
    disTitle:'Aviso de adivinación', disContent:'Mei Hua Yi Shu es un arte antiguo de reflexión y guía. Aunque ofrece perspectiva, <strong>no te bases solo en la adivinación</strong> para asuntos críticos como <span class="emphasis">decisiones de salud, financieras o legales</span>. Consulta a profesionales cuando importe.'
  },
  'fr': {
    langLabel:'Langue', modeObserve:'Observation', modeTime:'Temps', modeNumber:'Nombre / Symbole',
    observeGuide:'À l\u2019instant où votre question surgit, observez ce qui vous entoure. Qu\u2019est-ce qui attire d\u2019abord votre attention : un son, un objet, un nombre, une couleur, un mouvement ? C\u2019est votre présage.',
    observeLabel:'Qu\u2019est-ce qui a d\u2019abord attiré votre attention ?', observePlaceholder:'ex. un corbeau sur un panneau rouge, le nombre 7, une porte claquée',
    observeDirLabel:'Dans quelle direction était-ce, approximativement ? (facultatif)', observeNote:'La ligne mutante est fixée automatiquement selon l\u2019heure actuelle.',
    timeGuide:'L\u2019hexagramme est tiré de l\u2019instant exact de votre question : année, mois, jour et heure.', timeNote:'Les deux trigrammes et la ligne mutante découlent du moment présent. Gardez simplement votre question à l\u2019esprit.',
    numberGuide:'\u201CTout est nombre.\u201D Saisissez deux choses qui résonnent en vous : nombres, mots ou caractères.',
    upperLabel:'Source supérieure (Ciel)', upperPlaceholder:'ex. 7, Ciel, A', lowerLabel:'Source inférieure (Terre)', lowerPlaceholder:'ex. 3, Lac, B', numberNote:'La ligne mutante est fixée automatiquement selon l\u2019heure actuelle.',
    questionPlaceholder:'Concentrez-vous. Écrivez ici votre question précise\u2026', revealBtn:'Révéler la lecture',
    stepOracle:'L\u2019oracle parle', stepChart:'Analyse de l\u2019hexagramme', masterName:'L\u2019Oracle', timeNoteLoading:'Le raisonnement et l\u2019interprétation se font en deux étapes. Veuillez patienter.',
    timestampLabel:'Moment de la divination :', guaOriginal:'Original', guaNuclear:'Nucléaire', guaTransformed:'Transformé',
    computing:'Tirage de l\u2019hexagramme\u2026', stageFmt:'Étape {n} / 2',
    alertQuestion:'Veuillez d\u2019abord écrire votre question.', alertObserve:'Veuillez décrire ce que vous avez remarqué autour de vous.', alertNumber:'Veuillez remplir les deux champs.',
    stage1:['Tirage et évaluation de la relation Ti-Yong.','Lecture de l\u2019hexagramme nucléaire et transformé.'],
    stage2:['Rédaction de la lecture dans votre langue.','Formulation des conseils et des étapes.'],
    dir:['Incertain','Nord','Nord-est','Est','Sud-est','Sud','Sud-ouest','Ouest','Nord-ouest'],
    tyMode:'Méthode', tySelf:'Soi (Ti)', tyUse:'Autre (Yong)', tyRelationNow:'Relation actuelle', tyOutcome:'Relation du résultat', tyStrength:'Force du Soi', tyMoving:'Ligne mutante', omenLabel:'Présage observé',
    disTitle:'Avis de divination', disContent:'Le Mei Hua Yi Shu est un art ancien de réflexion et de guidance. Bien qu\u2019il offre une perspective, <strong>ne vous fiez pas à la seule divination</strong> pour des sujets cruciaux comme <span class="emphasis">la santé, les finances ou le juridique</span>. Consultez des professionnels quand c\u2019est important.'
  },
  'de': {
    langLabel:'Sprache', modeObserve:'Beobachtung', modeTime:'Zeit', modeNumber:'Zahl / Symbol',
    observeGuide:'In dem Moment, in dem deine Frage auftaucht, beachte deine Umgebung. Was fällt dir zuerst auf \u2014 ein Geräusch, ein Gegenstand, eine Zahl, eine Farbe, eine Bewegung? Das ist dein Omen.',
    observeLabel:'Was fiel dir zuerst auf?', observePlaceholder:'z. B. eine Krähe auf rotem Schild, die Zahl 7, eine zugeschlagene Tür',
    observeDirLabel:'In welcher Richtung war es ungefähr? (optional)', observeNote:'Die wandelnde Linie wird automatisch aus der aktuellen Stunde bestimmt.',
    timeGuide:'Das Hexagramm wird aus dem genauen Moment deiner Frage gebildet: Jahr, Monat, Tag und Stunde.', timeNote:'Beide Trigramme und die wandelnde Linie ergeben sich aus dem gegenwärtigen Moment. Halte nur deine Frage im Sinn.',
    numberGuide:'\u201EAlles ist Zahl.\u201C Gib zwei Dinge ein, die mit dir resonieren \u2014 Zahlen, Wörter oder Zeichen.',
    upperLabel:'Obere Quelle (Himmel)', upperPlaceholder:'z. B. 7, Himmel, A', lowerLabel:'Untere Quelle (Erde)', lowerPlaceholder:'z. B. 3, See, B', numberNote:'Die wandelnde Linie wird automatisch aus der aktuellen Stunde bestimmt.',
    questionPlaceholder:'Sammle dich. Schreibe hier deine konkrete Frage\u2026', revealBtn:'Deutung enthüllen',
    stepOracle:'Das Orakel spricht', stepChart:'Hexagramm-Analyse', masterName:'Das Orakel', timeNoteLoading:'Analyse und Deutung erfolgen in zwei Schritten. Bitte habe Geduld.',
    timestampLabel:'Zeitpunkt der Weissagung:', guaOriginal:'Original', guaNuclear:'Kern', guaTransformed:'Gewandelt',
    computing:'Hexagramm wird gebildet\u2026', stageFmt:'Schritt {n} / 2',
    alertQuestion:'Bitte schreibe zuerst deine Frage.', alertObserve:'Bitte beschreibe, was dir in deiner Umgebung auffiel.', alertNumber:'Bitte fülle beide Felder aus.',
    stage1:['Bildung und Abwägung der Ti-Yong-Beziehung.','Lesen des Kern- und des gewandelten Hexagramms.'],
    stage2:['Verfassen der Deutung in deiner Sprache.','Formulieren der Hinweise und nächsten Schritte.'],
    dir:['Unsicher','Norden','Nordosten','Osten','Südosten','Süden','Südwesten','Westen','Nordwesten'],
    tyMode:'Methode', tySelf:'Selbst (Ti)', tyUse:'Anderes (Yong)', tyRelationNow:'Aktuelle Beziehung', tyOutcome:'Ergebnis-Beziehung', tyStrength:'Stärke des Selbst', tyMoving:'Wandelnde Linie', omenLabel:'Beobachtetes Omen',
    disTitle:'Hinweis zur Weissagung', disContent:'Mei Hua Yi Shu ist eine alte Kunst zur Reflexion und Orientierung. Sie bietet Perspektive, doch <strong>verlasse dich nicht allein auf Weissagung</strong> bei kritischen Themen wie <span class="emphasis">Gesundheit, Finanzen oder Recht</span>. Ziehe bei Bedarf qualifizierte Fachleute hinzu.'
  }
};

/* ---- 提示词构造（两段式，诚实、加深） ---- */
const MH_Prompt = {
  buildFacts(d) {
    let f = '';
    f += '【起卦方式】' + d.modeCN + '\n';
    if (d.omenText) f += '【外应所见】' + d.omenText + (d.omenDir ? ('；方位：' + d.omenDir) : '') + '\n';
    f += '【起卦时间】' + d.timeText + '\n';
    f += '【问题】' + d.question + '\n';
    f += '【本卦】' + d.benName + '（上卦 ' + d.upperCN + '，下卦 ' + d.lowerCN + '）\n';
    f += '【互卦】' + d.huName + '（事情的内在/发展过程）\n';
    f += '【变卦】' + d.bianName + '（最终结果）；动爻：第 ' + d.movingYao + ' 爻\n';
    f += '【体卦（自身）】' + d.tiCN + '（' + d.tiElem + '），当令旺衰：' + d.tiStrength + '\n';
    f += '【用卦（对方/所问之事）】' + d.yongCN + '（' + d.yongElem + '）\n';
    f += '【当前体用关系】用卦 ' + d.benRelation + '\n';
    f += '【结果关系】变卦中的用卦 ' + d.outcomeRelation + '\n';
    return f;
  },
  buildJudgment(facts) {
    let p = '你是一位经验老到的梅花易数断卦师。下面这一卦已由程序按邵雍体用之法排定，数据可信，无需重排。请据此做专业、忠于卦象、有理有据的推断——核心是把"卦中出现了什么 → 在卦理上代表什么 → 对所问之事造成什么结果"这条因果链讲透。\n\n';
    p += facts + '\n';
    p += '请用中文输出，约 500 字，按以下条目逐项讲清因果，不堆砌套话：\n';
    p += '1. 总体结论：从 吉 / 小吉 / 平参半 / 小凶 / 凶 中选一个，并说清能不能成、利不利。\n';
    p += '2. 体用生克：这是梅花断吉凶的根本。用生体/体克用多主吉，用克体/体生用多主不利或耗力，比和主平顺。结合体卦旺衰（旺则能任、衰则力不足），说清当前吉凶。\n';
    p += '3. 本卦卦象：就所问之事，本卦之象说明了什么处境。\n';
    p += '4. 互卦：代表事情的内在隐情与发展过程，指出过程中的关键。\n';
    p += '5. 变卦：代表结果走向；结合"变卦之用对体的生克"，说明结局是变好还是变差。\n';
    if (facts.indexOf('外应') !== -1) p += '6. 外应呼应：把求测者所见之象（外应）与卦象合参，外应常对卦理起印证或点睛作用，指出它在此卦中的提示。\n';
    p += '7. 建议方向：如实给出。吉则言可进；凶不要粉饰，明说不利，并给可行的替代/补救与更合适的时机。\n';
    p += '\n要求：该吉言吉、该凶言凶，不为好听而夸大或回避；每条要有卦理依据，不要只下结论；不使用任何 emoji 或装饰符号。';
    return p;
  },
  buildInterpretation(facts, judgment, lang) {
    const tl = MH_LANG_AI[lang] || 'English';
    let p = 'You are a seasoned, composed Mei Hua Yi Shu (Plum Blossom Oracle) master. The hexagram has been computed and a preliminary professional judgment made. Write the FULL final reading for the querent \u2014 thorough and satisfying, not a brief summary.\n\n';
    p += 'CRITICAL: Write ENTIRELY in ' + tl + '.\n\n';
    p += '=== PRELIMINARY JUDGMENT (authoritative \u2014 do not contradict) ===\n' + judgment + '\n\n';
    p += '=== CHART FACTS (for detail, do not recompute) ===\n' + facts + '\n\n';
    p += '=== DEPTH REQUIREMENT (most important) ===\n';
    p += '- This must be an in-depth reading. The "Key analysis" section is the heart and should be the longest part.\n';
    p += '- For EVERY meaningful element, explain the full chain: WHAT appears -> WHAT it means in Mei Hua theory -> WHAT consequence it has for THIS question. Never just name a term.\n';
    p += '- Walk through: the original hexagram\u2019s image for this question; the Ti-Yong (Self vs Other/matter) relationship and what it implies about success or struggle; the Self trigram\u2019s seasonal strength and whether it is strong enough to carry the matter; the nuclear hexagram as the inner/hidden process; and the transformed hexagram (with its Ti-Yong relation) as the outcome.\n';
    if (facts.indexOf('外应') !== -1) p += '- IMPORTANT: weave in the querent\u2019s observed omen (what they actually noticed around them). Treat it as a meaningful external sign that echoes or sharpens the hexagram, and connect its imagery to the reading concretely.\n';
    p += '\n=== TONE ===\n';
    p += '- Be HONEST and faithful to the judgment. If the outcome is unfavorable, say so plainly and with empathy; do not pretend it is fine.\n';
    p += '- Do not exaggerate good news, do not dramatize bad news, do not catastrophize health/money/legal matters. No mystical hype, no flattery, no fear-mongering, no emoji.\n';
    p += '- Always pair an honest verdict with constructive guidance and a realistic next step.\n\n';
    p += '=== STRUCTURE (clear headings in ' + tl + ', this order) ===\n';
    p += '1. Conclusion FIRST \u2014 answer the question directly and state the verdict (2-4 sentences).\n';
    p += '2. Hexagram & omen \u2014 the original hexagram\u2019s meaning here' + (facts.indexOf('外应')!==-1 ? ', and how the observed omen relates' : '') + '.\n';
    p += '3. Key analysis \u2014 the detailed phenomenon-by-phenomenon explanation from the DEPTH REQUIREMENT (longest section, each factor as cause -> effect).\n';
    p += '4. Guidance \u2014 honest and constructive, several concrete actionable points, with a sense of better/worse timing if the chart suggests it.\n';
    p += '5. Closing \u2014 brief, steady, respectful.\n';
    return p;
  },
  buildCombined(facts, lang) {
    const tl = MH_LANG_AI[lang] || 'English';
    let p = 'You are a seasoned, composed Mei Hua Yi Shu master. The hexagram is already computed (values reliable; do not recompute). Write the FULL final reading \u2014 thorough, not brief.\n\n';
    p += 'CRITICAL: Write ENTIRELY in ' + tl + '.\n\n';
    p += '=== CHART FACTS ===\n' + facts + '\n\n';
    p += '=== DEPTH ===\nFor every element explain WHAT appears -> WHAT it means -> WHAT consequence for this question. Cover the original hexagram image, the Ti-Yong relationship, the Self trigram strength, the nuclear hexagram (inner process), and the transformed hexagram (outcome).';
    if (facts.indexOf('外应') !== -1) p += ' Weave in the observed omen as a meaningful external sign.';
    p += ' The Key analysis section should be the longest.\n\n';
    p += '=== TONE ===\nHonest and faithful to the computed verdict. No exaggeration, no catastrophizing, no mystical hype, no emoji. Pair the verdict with constructive guidance.\n\n';
    p += '=== STRUCTURE (headings in ' + tl + ', this order) ===\n1. Conclusion FIRST (state the verdict). 2. Hexagram & omen. 3. Key analysis (longest, cause->effect). 4. Honest constructive guidance. 5. Brief closing.\n';
    return p;
  }
};

/* ---- 主类 ---- */
class MeihuaDivination {
  constructor(container) {
    if (!container) return;
    this.container = container;
    this.sectionId = container.id.replace('meihua-app-', '');
    this.uiLang = 'en';
    this.aiServerUrl = container.dataset.aiUrl;

    const id = this.sectionId;
    this.divineBtn = document.getElementById('divine-btn-' + id);
    this.resultContainer = document.getElementById('result-container-' + id);
    this.aiContent = document.getElementById('ai-content-' + id);
    this.questionInput = document.getElementById('meihua-question-' + id);
    this.timestampEl = document.getElementById('meihua-timestamp-' + id);
    this.observeText = document.getElementById('observe-text-' + id);
    this.observeDir = document.getElementById('observe-dir-' + id);
    this.upperInput = document.getElementById('upper-num-' + id);
    this.lowerInput = document.getElementById('lower-num-' + id);
    this.tiyongDetail = document.getElementById('tiyong-detail-' + id);
    this.loadingSpinner = document.getElementById('loading-spinner-' + id);
    this.stageIndicator = document.getElementById('stage-indicator-' + id);
    this.dynamicAction = document.getElementById('dynamic-action-' + id);

    this.modeRadios = container.querySelectorAll('input[name="divination-mode-' + id + '"]');
    this.modePanels = { observe: document.getElementById('observe-inputs-' + id), time: document.getElementById('time-inputs-' + id), number: document.getElementById('number-inputs-' + id) };
    this.langTabs = container.querySelectorAll('.oracle-language-tab');

    this.modeRadios.forEach(r => r.addEventListener('change', () => this.handleModeChange()));
    this.langTabs.forEach(tab => tab.addEventListener('click', () => this.applyLanguage(tab.getAttribute('data-lang'))));
    this.divineBtn.addEventListener('click', () => this.runDivination());

    this.applyLanguage('en');
  }

  t(key) { const c = MH_UI[this.uiLang] || MH_UI.en; return c[key] !== undefined ? c[key] : MH_UI.en[key]; }
  delay(ms) { return new Promise(r => setTimeout(r, ms)); }

  applyLanguage(lang) {
    this.uiLang = lang;
    this.langTabs.forEach(t => t.classList.toggle('active', t.getAttribute('data-lang') === lang));
    this.container.querySelectorAll('[data-i18n]').forEach(el => { const v = this.t(el.getAttribute('data-i18n')); if (typeof v === 'string') el.textContent = v; });
    this.container.querySelectorAll('[data-i18n-ph]').forEach(el => { const v = this.t(el.getAttribute('data-i18n-ph')); if (v !== undefined) el.setAttribute('placeholder', v); });
    // 方位下拉
    if (this.observeDir) {
      const labels = this.t('dir'); const prev = this.observeDir.value;
      this.observeDir.innerHTML = MH_DIR_ORDER.map((k, i) => '<option value="' + k + '">' + labels[i] + '</option>').join('');
      if (prev) this.observeDir.value = prev;
    }
    // 免责声明
    const dt = this.container.querySelector('.disclaimer-title-meihua');
    const dc = this.container.querySelector('.disclaimer-content-meihua');
    if (dt) dt.textContent = this.t('disTitle');
    if (dc) dc.innerHTML = this.t('disContent');
  }

  handleModeChange() {
    const mode = this.container.querySelector('input[name="divination-mode-' + this.sectionId + '"]:checked').value;
    Object.keys(this.modePanels).forEach(k => { if (this.modePanels[k]) this.modePanels[k].classList.toggle('hidden', k !== mode); });
  }

  getInputScore(value) {
    if (!value) return 0;
    if (/^\d+$/.test(value)) return parseInt(value, 10);
    let s = 0; for (let i = 0; i < value.length; i++) s += value.charCodeAt(i);
    return s;
  }
  checkRelation(e1, e2) {
    if (e1 === e2) return 'Same (Support)';
    if (MH_WUXING[e1 + ',' + e2] === 'Birth') return 'Generates (Drains strength)';
    if (MH_WUXING[e2 + ',' + e1] === 'Birth') return 'Generated by (Increases strength)';
    if (MH_WUXING[e1 + ',' + e2] === 'Clash') return 'Clashes (Conquers)';
    if (MH_WUXING[e2 + ',' + e1] === 'Clash') return 'Clashed by (Damaged)';
    return 'Unknown';
  }
  getSeasonStrength(element, month) {
    let se = 'Earth';
    if ([1,2].includes(month)) se = 'Wood';
    else if ([4,5].includes(month)) se = 'Fire';
    else if ([7,8].includes(month)) se = 'Metal';
    else if ([10,11].includes(month)) se = 'Water';
    if (element === se) return 'Strongest (Wang)';
    if (MH_WUXING[se + ',' + element] === 'Birth') return 'Strong (Xiang)';
    if (MH_WUXING[element + ',' + se] === 'Birth') return 'Weak (Xiu)';
    if (MH_WUXING[element + ',' + se] === 'Clash') return 'Trapped (Qiu)';
    return 'Dead (Si)';
  }
  getGuaByYaos(yaos) {
    const s = JSON.stringify(yaos);
    for (const n in MH_GUA_YAOS) if (JSON.stringify(MH_GUA_YAOS[n]) === s) return parseInt(n);
    return null;
  }
  renderGua(type, upperN, lowerN) {
    const sy = document.getElementById(type + '-gua-symbol-' + this.sectionId);
    const nm = document.getElementById(type + '-gua-name-' + this.sectionId);
    if (!upperN || !lowerN) { sy.innerText = ' '; nm.innerText = '\u2026'; return; }
    sy.innerText = MH_GUA_DATA[upperN].symbol + '\n' + MH_GUA_DATA[lowerN].symbol;
    const hex = MH_HEXAGRAMS[upperN + '' + lowerN] || (MH_GUA_DATA[upperN].name + ' / ' + MH_GUA_DATA[lowerN].name);
    nm.innerHTML = '<strong>' + hex + '</strong><br><span style="font-size:0.8em;color:#777;">(' + MH_GUA_DATA[upperN].cn + ' / ' + MH_GUA_DATA[lowerN].cn + ')</span>';
  }

  parseMarkdown(text) {
    let s = String(text).replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const lines = s.split('\n'); let out = ''; let inList = false; let listType = '';
    const closeList = () => { if (inList) { out += listType === 'ol' ? '</ol>' : '</ul>'; inList = false; listType = ''; } };
    for (let raw of lines) {
      let line = raw.trim();
      if (!line) { closeList(); continue; }
      let h = line.match(/^(#{1,4})\s+(.*)$/);
      if (h) { closeList(); out += '<h3>' + h[2] + '</h3>'; continue; }
      let ol = line.match(/^\d+[\.\)]\s+(.*)$/);
      let ul = line.match(/^[-*\u2022]\s+(.*)$/);
      if (ol) { if (!inList || listType !== 'ol') { closeList(); out += '<ol>'; inList = true; listType = 'ol'; } out += '<li>' + ol[1] + '</li>'; continue; }
      if (ul) { if (!inList || listType !== 'ul') { closeList(); out += '<ul>'; inList = true; listType = 'ul'; } out += '<li>' + ul[1] + '</li>'; continue; }
      closeList(); out += '<p>' + line + '</p>';
    }
    closeList();
    return out.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  }

  setStage(n) { if (this.stageIndicator) this.stageIndicator.textContent = this.t('stageFmt').replace('{n}', n); }
  startActions(arr) {
    let i = 0; if (!this.dynamicAction) return; this.dynamicAction.textContent = arr[0];
    this.actionTimer = setInterval(() => { i = (i + 1) % arr.length; this.dynamicAction.style.opacity = '0'; setTimeout(() => { this.dynamicAction.textContent = arr[i]; this.dynamicAction.style.opacity = '1'; }, 300); }, 2400);
  }
  stopActions() { if (this.actionTimer) { clearInterval(this.actionTimer); this.actionTimer = null; } }

  async callAI(prompt) {
    const res = await fetch(this.aiServerUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ prompt: prompt }) });
    if (!res.ok) throw new Error('Server ' + res.status);
    const data = await res.json();
    return data.response;
  }

  async runDivination() {
    const question = this.questionInput.value.trim();
    if (!question) { alert(this.t('alertQuestion')); this.questionInput.focus(); return; }
    const lang = this.uiLang;
    const mode = this.container.querySelector('input[name="divination-mode-' + this.sectionId + '"]:checked').value;

    const now = new Date();
    const hour = now.getHours();
    let shichen = (hour >= 23 || hour === 0) ? 1 : Math.floor((hour + 1) / 2) + 1;

    // 农历信息（用于时间起卦与显示），lunar.js 不可用则退回公历
    let lunarMonth = now.getMonth() + 1, lunarDay = now.getDate(), lunarYearZhi = 1, timeText = '', haveLunar = false;
    if (typeof Lunar !== 'undefined') {
      try {
        let d = new Date(now); if (hour >= 23) d.setDate(d.getDate() + 1);
        const lo = Lunar.fromDate(d);
        lunarMonth = lo.getMonth(); lunarDay = lo.getDay();
        const zhiMap = {'子':1,'丑':2,'寅':3,'卯':4,'辰':5,'巳':6,'午':7,'未':8,'申':9,'酉':10,'戌':11,'亥':12};
        lunarYearZhi = zhiMap[lo.getYearInGanZhi().substring(1)] || 1;
        timeText = '公历 ' + now.getFullYear() + '-' + (now.getMonth()+1) + '-' + now.getDate() + ' ' + String(hour).padStart(2,'0') + ':' + String(now.getMinutes()).padStart(2,'0') + '；农历 ' + lo.getYearInGanZhi() + '年 ' + lo.getMonthInChinese() + '月 ' + lo.getDayInChinese() + '（第' + shichen + '时辰）';
        haveLunar = true;
      } catch (e) { haveLunar = false; }
    }
    if (!haveLunar) {
      timeText = now.getFullYear() + '-' + (now.getMonth()+1) + '-' + now.getDate() + ' ' + String(hour).padStart(2,'0') + ':' + String(now.getMinutes()).padStart(2,'0') + '（公历，第' + shichen + '时辰）';
    }

    // 起卦
    let upperNum, lowerNum, movingYao, omenText = '', omenDir = '';
    if (mode === 'observe') {
      const obs = this.observeText.value.trim();
      if (!obs) { alert(this.t('alertObserve')); this.observeText.focus(); return; }
      omenText = obs;
      const dirKey = this.observeDir ? this.observeDir.value : 'unsure';
      const score = this.getInputScore(obs);
      if (dirKey && dirKey !== 'unsure' && MH_DIR_GUA[dirKey]) {
        upperNum = MH_DIR_GUA[dirKey];
        lowerNum = (score % 8) || 8;
        const dirLabels = this.t('dir'); omenDir = dirLabels[MH_DIR_ORDER.indexOf(dirKey)] || '';
      } else {
        upperNum = (score % 8) || 8;
        lowerNum = ((score + obs.length) % 8) || 8;
      }
      movingYao = ((upperNum + lowerNum + shichen) % 6) || 6;
    } else if (mode === 'number') {
      const a = this.upperInput.value, b = this.lowerInput.value;
      const sa = this.getInputScore(a), sb = this.getInputScore(b);
      if (sa === 0 || sb === 0) { alert(this.t('alertNumber')); return; }
      upperNum = (sa % 8) || 8; lowerNum = (sb % 8) || 8; movingYao = ((sa + sb + shichen) % 6) || 6;
    } else { // time
      const y = lunarYearZhi, m = lunarMonth, da = lunarDay;
      upperNum = ((y + m + da) % 8) || 8;
      lowerNum = ((y + m + da + shichen) % 8) || 8;
      movingYao = ((y + m + da + shichen) % 6) || 6;
    }

    // 三卦
    const benUpper = MH_GUA_YAOS[upperNum], benLower = MH_GUA_YAOS[lowerNum];
    const benLines = [...benLower, ...benUpper];
    const huLowerNum = this.getGuaByYaos(benLines.slice(1, 4));
    const huUpperNum = this.getGuaByYaos(benLines.slice(2, 5));
    const bianLines = [...benLines]; bianLines[movingYao - 1] = 1 - bianLines[movingYao - 1];
    const bianLowerNum = this.getGuaByYaos(bianLines.slice(0, 3));
    const bianUpperNum = this.getGuaByYaos(bianLines.slice(3, 6));

    // 体用
    const isUpperMoving = movingYao > 3;
    const tiNum = isUpperMoving ? lowerNum : upperNum;
    const yongNum = isUpperMoving ? upperNum : lowerNum;
    const tiGua = MH_GUA_DATA[tiNum], yongGua = MH_GUA_DATA[yongNum];
    const tiStrengthEn = this.getSeasonStrength(tiGua.element, lunarMonth);
    const benRelationEn = this.checkRelation(tiGua.element, yongGua.element);
    const bianYongNum = isUpperMoving ? bianUpperNum : bianLowerNum;
    const bianYongGua = MH_GUA_DATA[bianYongNum];
    const outcomeRelationEn = this.checkRelation(tiGua.element, bianYongGua.element);

    // 渲染时间戳 + 结果区
    if (this.timestampEl) this.timestampEl.textContent = now.toLocaleString(undefined, { year:'numeric', month:'short', day:'numeric', hour:'2-digit', minute:'2-digit' });
    this.resultContainer.style.display = 'block';
    this.divineBtn.disabled = true;

    // 卦象动画
    this.aiContent.innerHTML = '';
    await this.delay(300);
    this.renderGua('ben', upperNum, lowerNum);
    await this.delay(450);
    this.renderGua('hu', huUpperNum, huLowerNum);
    await this.delay(450);
    this.renderGua('bian', bianUpperNum, bianLowerNum);
    this.renderTiyong({ mode, omenText, omenDir, tiGua, yongGua, tiStrengthEn, benRelationEn, outcomeRelationEn, movingYao });

    // facts
    const modeCN = mode === 'observe' ? '观物外应' : (mode === 'time' ? '时间起卦' : '数字/象起卦');
    const facts = MH_Prompt.buildFacts({
      modeCN, omenText, omenDir, timeText, question,
      benName: MH_HEXAGRAMS[upperNum + '' + lowerNum] || (tiGua.name),
      upperCN: MH_GUA_DATA[upperNum].cn, lowerCN: MH_GUA_DATA[lowerNum].cn,
      huName: MH_HEXAGRAMS[huUpperNum + '' + huLowerNum] || '—',
      bianName: MH_HEXAGRAMS[bianUpperNum + '' + bianLowerNum] || '—', movingYao,
      tiCN: tiGua.cn, tiElem: MH_ELEM_CN[tiGua.element], tiStrength: MH_SEASON_CN[tiStrengthEn] || tiStrengthEn,
      yongCN: yongGua.cn, yongElem: MH_ELEM_CN[yongGua.element],
      benRelation: MH_REL_CN[benRelationEn] || benRelationEn,
      outcomeRelation: MH_REL_CN[outcomeRelationEn] || outcomeRelationEn
    });

    // 两段式
    this.loadingSpinner.classList.remove('hidden');
    let finalText = '';
    try {
      this.setStage(1); this.startActions(this.t('stage1'));
      let judgment;
      try {
        judgment = await this.callAI(MH_Prompt.buildJudgment(facts));
      } catch (e1) {
        // 第一段失败 -> 单次回退
        this.setStage(2); this.stopActions(); this.startActions(this.t('stage2'));
        finalText = await this.callAI(MH_Prompt.buildCombined(facts, lang));
      }
      if (judgment) {
        this.setStage(2); this.stopActions(); this.startActions(this.t('stage2'));
        finalText = await this.callAI(MH_Prompt.buildInterpretation(facts, judgment, lang));
      }
      this.stopActions(); this.loadingSpinner.classList.add('hidden');
      this.aiContent.innerHTML = this.parseMarkdown(finalText);
    } catch (err) {
      this.stopActions(); this.loadingSpinner.classList.add('hidden');
      this.aiContent.innerHTML = '<p style="color:#c62828;text-align:center;">The connection was interrupted. Please try again.<br><small>(' + err.message + ')</small></p>';
    } finally {
      this.divineBtn.disabled = false;
    }
  }

  renderTiyong(d) {
    const row = (label, value, accent) => '<div class="tiyong-row"><span class="label">' + label + '</span><span class="value' + (accent ? ' accent' : '') + '">' + value + '</span></div>';
    const elemName = g => g.cn + '（' + (MH_ELEM_CN[g.element] || g.element) + '）';
    let h = '';
    h += row(this.t('tyMode'), this.t('mode' + (d.mode === 'observe' ? 'Observe' : d.mode === 'time' ? 'Time' : 'Number')));
    h += row(this.t('tySelf'), elemName(d.tiGua));
    h += row(this.t('tyUse'), elemName(d.yongGua));
    h += row(this.t('tyStrength'), MH_SEASON_CN[d.tiStrengthEn] || d.tiStrengthEn);
    h += row(this.t('tyRelationNow'), MH_REL_CN[d.benRelationEn] || d.benRelationEn, true);
    h += row(this.t('tyOutcome'), MH_REL_CN[d.outcomeRelationEn] || d.outcomeRelationEn, true);
    h += row(this.t('tyMoving'), d.movingYao + '');
    if (d.omenText) h += '<div class="omen-note"><strong>' + this.t('omenLabel') + '：</strong>' + d.omenText.replace(/</g,'&lt;') + (d.omenDir ? ('（' + d.omenDir + '）') : '') + '</div>';
    this.tiyongDetail.innerHTML = h;
  }
}

const initMeihua = () => {
  document.querySelectorAll('.meihua-app-container').forEach(c => { if (!c.dataset.initialized) { new MeihuaDivination(c); c.dataset.initialized = '1'; } });
};
document.addEventListener('DOMContentLoaded', initMeihua);
document.addEventListener('shopify:section:load', initMeihua);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zhougong-dream"] && !Shopify.designMode) return;
  try {
    
class DreamInterpreter {
  constructor(container) {
    if (!container) return;
    this.container = container;
    this.sectionId = container.id.replace('dream-app-', '');
    
    // Elements
    this.interpretBtn = document.getElementById(`interpret-btn-${this.sectionId}`);
    this.resultContainer = document.getElementById(`result-container-${this.sectionId}`);
    this.aiContent = document.getElementById(`ai-content-${this.sectionId}`);
    this.dreamInput = document.getElementById(`dream-content-${this.sectionId}`);
    this.timestampEl = document.getElementById(`dream-timestamp-${this.sectionId}`);
    this.countBadge = document.getElementById(`dream-count-badge-${this.sectionId}`);

    // Config
    this.aiServerUrl = this.container.dataset.aiUrl;
    this.defaultButtonText = this.container.dataset.buttonText;
    this.currentLang = 'English';

    // Dream count storage
    this.STORAGE_KEY = 'dream_interpreter_count_v2';
    this.BASE_COUNT = 1000;

    // All UI translations
    this.uiTranslations = {
      'English': {
        langLabel: 'Analysis Language:',
        disclaimer: {
          title: 'Interpretation Notice',
          content: 'Dream interpretation is an ancient art combining Zhou Gong wisdom with modern psychology. While it offers valuable self-reflection, <strong>please do not rely solely on dream analysis</strong> for critical matters such as <span class="emphasis">health diagnosis, financial decisions, or relationship choices</span>. Seek qualified professionals when necessary.'
        },
        inputLabel: 'Describe Your Dream',
        inputPlaceholder: 'Please describe your dream in detail: scenes, characters, events, colors, objects...',
        inputHint: 'The more details you provide, the more accurate the interpretation.',
        emotionLabel: 'How Did You Feel Upon Waking?',
        emotions: {
          fear: 'Fear / Panic',
          confused: 'Confused',
          calm: 'Calm / Peaceful',
          sad: 'Sad',
          excited: 'Excited / Happy',
          angry: 'Angry / Irritated',
          neutral: 'No Particular Feeling'
        },
        clarityLabel: 'Dream Clarity',
        clarity: {
          vivid: 'Very Vivid',
          blurry: 'Blurry',
          fragments: 'Only Fragments'
        },
        button: 'Interpret My Dream',
        buttonLoading: 'Consulting Ancient Texts...',
        privacy: 'Your dream content is used only for this analysis and is never stored.',
        summaryEmotion: 'Dream Emotion',
        summaryClarity: 'Dream Clarity',
        summaryTime: 'Analysis Time',
        resultTitle: 'Your Dream Interpretation',
        timestampLabel: 'Time of Interpretation: ',
        dreamCount: '{count} dreams interpreted',
        gate: {
          title: 'Unlock Complete Interpretation',
          subtitle: 'Enter your email to reveal the full analysis, including spiritual guidance and actionable advice.',
          button: 'Unlock',
          privacy: 'We respect your privacy. Unsubscribe anytime.',
          success: 'Full interpretation unlocked!',
          error: 'Please enter a valid email.'
        },
        error: 'Unable to interpret at this time. Please try again.'
      },
      'zh-CN': {
        langLabel: '解析语言：',
        disclaimer: {
          title: '解梦须知',
          content: '周公解梦结合古老智慧与现代心理学，仅供自我反思参考。<strong>请勿将梦境解析作为重大决策的唯一依据</strong>，特别是涉及<span class="emphasis">健康诊断、财务决策或情感选择</span>时。遇到严肃问题请咨询专业人士。'
        },
        inputLabel: '描述您的梦境',
        inputPlaceholder: '请详细描述您的梦境：场景、人物、事件、颜色、物品...',
        inputHint: '描述越详细，解读越准确。',
        emotionLabel: '醒来后的感觉',
        emotions: {
          fear: '恐惧 / 心慌',
          confused: '困惑 / 不解',
          calm: '平静 / 安详',
          sad: '悲伤 / 难过',
          excited: '兴奋 / 快乐',
          angry: '愤怒 / 烦躁',
          neutral: '无特别感觉'
        },
        clarityLabel: '梦境清晰度',
        clarity: {
          vivid: '非常清晰',
          blurry: '模糊不清',
          fragments: '只记得片段'
        },
        button: '解读我的梦',
        buttonLoading: '正在查阅古籍...',
        privacy: '您的梦境内容仅用于本次解析，不会被存储。',
        summaryEmotion: '梦醒情绪',
        summaryClarity: '梦境清晰度',
        summaryTime: '解析时间',
        resultTitle: '您的梦境解读',
        timestampLabel: '解读时间：',
        dreamCount: '已为 {count} 人解梦',
        gate: {
          title: '解锁完整解读',
          subtitle: '输入您的邮箱，获取完整解析，包括灵境指引和具体行动建议。',
          button: '解锁',
          privacy: '我们尊重您的隐私，可随时退订。',
          success: '完整解读已解锁！',
          error: '请输入有效的邮箱地址。'
        },
        error: '暂时无法解析，请稍后再试。'
      },
      'zh-TW': {
        langLabel: '解析語言：',
        disclaimer: {
          title: '解夢須知',
          content: '周公解夢結合古老智慧與現代心理學，僅供自我反思參考。<strong>請勿將夢境解析作為重大決策的唯一依據</strong>，特別是涉及<span class="emphasis">健康診斷、財務決策或情感選擇</span>時。遇到嚴肅問題請諮詢專業人士。'
        },
        inputLabel: '描述您的夢境',
        inputPlaceholder: '請詳細描述您的夢境：場景、人物、事件、顏色、物品...',
        inputHint: '描述越詳細，解讀越準確。',
        emotionLabel: '醒來後的感覺',
        emotions: {
          fear: '恐懼 / 心慌',
          confused: '困惑 / 不解',
          calm: '平靜 / 安詳',
          sad: '悲傷 / 難過',
          excited: '興奮 / 快樂',
          angry: '憤怒 / 煩躁',
          neutral: '無特別感覺'
        },
        clarityLabel: '夢境清晰度',
        clarity: {
          vivid: '非常清晰',
          blurry: '模糊不清',
          fragments: '只記得片段'
        },
        button: '解讀我的夢',
        buttonLoading: '正在查閱古籍...',
        privacy: '您的夢境內容僅用於本次解析，不會被存儲。',
        summaryEmotion: '夢醒情緒',
        summaryClarity: '夢境清晰度',
        summaryTime: '解析時間',
        resultTitle: '您的夢境解讀',
        timestampLabel: '解讀時間：',
        dreamCount: '已為 {count} 人解夢',
        gate: {
          title: '解鎖完整解讀',
          subtitle: '輸入您的郵箱，獲取完整解析，包括靈境指引和具體行動建議。',
          button: '解鎖',
          privacy: '我們尊重您的隱私，可隨時退訂。',
          success: '完整解讀已解鎖！',
          error: '請輸入有效的郵箱地址。'
        },
        error: '暫時無法解析，請稍後再試。'
      },
      'Spanish': {
        langLabel: 'Idioma del Analisis:',
        disclaimer: {
          title: 'Aviso de Interpretacion',
          content: 'La interpretacion de suenos combina sabiduria antigua con psicologia moderna. <strong>No confie unicamente en el analisis de suenos</strong> para asuntos criticos como <span class="emphasis">diagnostico de salud, decisiones financieras o elecciones de relaciones</span>. Consulte profesionales cuando sea necesario.'
        },
        inputLabel: 'Describe Tu Sueno',
        inputPlaceholder: 'Por favor describe tu sueno en detalle: escenas, personajes, eventos, colores, objetos...',
        inputHint: 'Cuantos mas detalles proporciones, mas precisa sera la interpretacion.',
        emotionLabel: 'Como Te Sentiste al Despertar?',
        emotions: {
          fear: 'Miedo / Panico',
          confused: 'Confundido',
          calm: 'Tranquilo / En Paz',
          sad: 'Triste',
          excited: 'Emocionado / Feliz',
          angry: 'Enojado / Irritado',
          neutral: 'Sin Sentimiento Particular'
        },
        clarityLabel: 'Claridad del Sueno',
        clarity: {
          vivid: 'Muy Vivido',
          blurry: 'Borroso',
          fragments: 'Solo Fragmentos'
        },
        button: 'Interpretar Mi Sueno',
        buttonLoading: 'Consultando Textos Antiguos...',
        privacy: 'El contenido de tu sueno solo se usa para este analisis y nunca se almacena.',
        summaryEmotion: 'Emocion del Sueno',
        summaryClarity: 'Claridad del Sueno',
        summaryTime: 'Hora del Analisis',
        resultTitle: 'Tu Interpretacion del Sueno',
        timestampLabel: 'Hora de Interpretacion: ',
        dreamCount: '{count} suenos interpretados',
        gate: {
          title: 'Desbloquear Interpretacion Completa',
          subtitle: 'Ingresa tu email para revelar el analisis completo, incluyendo guia espiritual y consejos practicos.',
          button: 'Desbloquear',
          privacy: 'Respetamos tu privacidad. Cancela cuando quieras.',
          success: 'Interpretacion completa desbloqueada!',
          error: 'Por favor ingresa un email valido.'
        },
        error: 'No se puede interpretar en este momento. Por favor intenta mas tarde.'
      },
      'French': {
        langLabel: 'Langue d\'Analyse:',
        disclaimer: {
          title: 'Avis d\'Interpretation',
          content: 'L\'interpretation des reves combine sagesse ancienne et psychologie moderne. <strong>Ne vous fiez pas uniquement a l\'analyse des reves</strong> pour des questions critiques comme <span class="emphasis">diagnostic de sante, decisions financieres ou choix relationnels</span>. Consultez des professionnels si necessaire.'
        },
        inputLabel: 'Decrivez Votre Reve',
        inputPlaceholder: 'Veuillez decrire votre reve en detail: scenes, personnages, evenements, couleurs, objets...',
        inputHint: 'Plus vous fournissez de details, plus l\'interpretation sera precise.',
        emotionLabel: 'Comment Vous Sentiez-Vous au Reveil?',
        emotions: {
          fear: 'Peur / Panique',
          confused: 'Confus',
          calm: 'Calme / Paisible',
          sad: 'Triste',
          excited: 'Excite / Heureux',
          angry: 'En Colere / Irrite',
          neutral: 'Pas de Sentiment Particulier'
        },
        clarityLabel: 'Clarte du Reve',
        clarity: {
          vivid: 'Tres Vivide',
          blurry: 'Flou',
          fragments: 'Seulement des Fragments'
        },
        button: 'Interpreter Mon Reve',
        buttonLoading: 'Consultation des Textes Anciens...',
        privacy: 'Le contenu de votre reve n\'est utilise que pour cette analyse et n\'est jamais stocke.',
        summaryEmotion: 'Emotion du Reve',
        summaryClarity: 'Clarte du Reve',
        summaryTime: 'Heure d\'Analyse',
        resultTitle: 'Votre Interpretation du Reve',
        timestampLabel: 'Heure d\'Interpretation: ',
        dreamCount: '{count} reves interpretes',
        gate: {
          title: 'Debloquer l\'Interpretation Complete',
          subtitle: 'Entrez votre email pour reveler l\'analyse complete, y compris les conseils spirituels.',
          button: 'Debloquer',
          privacy: 'Nous respectons votre vie privee. Desabonnement a tout moment.',
          success: 'Interpretation complete debloquee!',
          error: 'Veuillez entrer un email valide.'
        },
        error: 'Impossible d\'interpreter pour le moment. Veuillez reessayer plus tard.'
      },
      'German': {
        langLabel: 'Analysesprache:',
        disclaimer: {
          title: 'Interpretationshinweis',
          content: 'Traumdeutung verbindet alte Weisheit mit moderner Psychologie. <strong>Verlassen Sie sich nicht allein auf Traumanalyse</strong> bei kritischen Angelegenheiten wie <span class="emphasis">Gesundheitsdiagnose, Finanzentscheidungen oder Beziehungswahl</span>. Konsultieren Sie bei Bedarf Fachleute.'
        },
        inputLabel: 'Beschreiben Sie Ihren Traum',
        inputPlaceholder: 'Bitte beschreiben Sie Ihren Traum im Detail: Szenen, Charaktere, Ereignisse, Farben, Objekte...',
        inputHint: 'Je mehr Details Sie angeben, desto genauer die Interpretation.',
        emotionLabel: 'Wie Fuhlten Sie Sich Beim Aufwachen?',
        emotions: {
          fear: 'Angst / Panik',
          confused: 'Verwirrt',
          calm: 'Ruhig / Friedlich',
          sad: 'Traurig',
          excited: 'Aufgeregt / Glucklich',
          angry: 'Wutend / Gereizt',
          neutral: 'Kein Besonderes Gefuhl'
        },
        clarityLabel: 'Traumklarheit',
        clarity: {
          vivid: 'Sehr Lebhaft',
          blurry: 'Verschwommen',
          fragments: 'Nur Fragmente'
        },
        button: 'Meinen Traum Deuten',
        buttonLoading: 'Konsultiere Alte Texte...',
        privacy: 'Ihr Trauminhalt wird nur fur diese Analyse verwendet und nie gespeichert.',
        summaryEmotion: 'Traumemotion',
        summaryClarity: 'Traumklarheit',
        summaryTime: 'Analysezeit',
        resultTitle: 'Ihre Traumdeutung',
        timestampLabel: 'Interpretationszeit: ',
        dreamCount: '{count} Traume gedeutet',
        gate: {
          title: 'Vollstandige Deutung Freischalten',
          subtitle: 'Geben Sie Ihre E-Mail ein, um die vollstandige Analyse zu erhalten.',
          button: 'Freischalten',
          privacy: 'Wir respektieren Ihre Privatsphare. Jederzeit abbestellbar.',
          success: 'Vollstandige Deutung freigeschaltet!',
          error: 'Bitte geben Sie eine gultige E-Mail ein.'
        },
        error: 'Kann derzeit nicht interpretieren. Bitte versuchen Sie es spater erneut.'
      },
      'Dutch': {
        langLabel: 'Analysetaal:',
        disclaimer: {
          title: 'Interpretatiemelding',
          content: 'Droominterpretatie combineert oude wijsheid met moderne psychologie. <strong>Vertrouw niet alleen op droomanalyse</strong> voor kritieke zaken zoals <span class="emphasis">gezondheidsdiagnose, financiele beslissingen of relatiekeuzes</span>. Raadpleeg professionals indien nodig.'
        },
        inputLabel: 'Beschrijf Uw Droom',
        inputPlaceholder: 'Beschrijf uw droom in detail: scenes, personages, gebeurtenissen, kleuren, objecten...',
        inputHint: 'Hoe meer details u geeft, hoe nauwkeuriger de interpretatie.',
        emotionLabel: 'Hoe Voelde U Zich Bij het Wakker Worden?',
        emotions: {
          fear: 'Angst / Paniek',
          confused: 'Verward',
          calm: 'Kalm / Vredig',
          sad: 'Verdrietig',
          excited: 'Opgewonden / Blij',
          angry: 'Boos / Geirriteerd',
          neutral: 'Geen Bijzonder Gevoel'
        },
        clarityLabel: 'Droomhelderheid',
        clarity: {
          vivid: 'Zeer Levendig',
          blurry: 'Wazig',
          fragments: 'Alleen Fragmenten'
        },
        button: 'Interpreteer Mijn Droom',
        buttonLoading: 'Oude Teksten Raadplegen...',
        privacy: 'Uw droominhoud wordt alleen voor deze analyse gebruikt en wordt nooit opgeslagen.',
        summaryEmotion: 'Droomemotie',
        summaryClarity: 'Droomhelderheid',
        summaryTime: 'Analysetijd',
        resultTitle: 'Uw Droominterpretatie',
        timestampLabel: 'Interpretatietijd: ',
        dreamCount: '{count} dromen geinterpreteerd',
        gate: {
          title: 'Ontgrendel Volledige Interpretatie',
          subtitle: 'Voer uw e-mail in om de volledige analyse te onthullen.',
          button: 'Ontgrendelen',
          privacy: 'Wij respecteren uw privacy. Elk moment opzegbaar.',
          success: 'Volledige interpretatie ontgrendeld!',
          error: 'Voer een geldig e-mailadres in.'
        },
        error: 'Kan momenteel niet interpreteren. Probeer het later opnieuw.'
      },
      'Italian': {
        langLabel: 'Lingua di Analisi:',
        disclaimer: {
          title: 'Avviso di Interpretazione',
          content: 'L\'interpretazione dei sogni combina saggezza antica e psicologia moderna. <strong>Non affidarti solo all\'analisi dei sogni</strong> per questioni critiche come <span class="emphasis">diagnosi di salute, decisioni finanziarie o scelte relazionali</span>. Consulta professionisti quando necessario.'
        },
        inputLabel: 'Descrivi il Tuo Sogno',
        inputPlaceholder: 'Per favore descrivi il tuo sogno in dettaglio: scene, personaggi, eventi, colori, oggetti...',
        inputHint: 'Piu dettagli fornisci, piu accurata sara l\'interpretazione.',
        emotionLabel: 'Come Ti Sei Sentito al Risveglio?',
        emotions: {
          fear: 'Paura / Panico',
          confused: 'Confuso',
          calm: 'Calmo / In Pace',
          sad: 'Triste',
          excited: 'Emozionato / Felice',
          angry: 'Arrabbiato / Irritato',
          neutral: 'Nessun Sentimento Particolare'
        },
        clarityLabel: 'Chiarezza del Sogno',
        clarity: {
          vivid: 'Molto Vivido',
          blurry: 'Sfocato',
          fragments: 'Solo Frammenti'
        },
        button: 'Interpreta il Mio Sogno',
        buttonLoading: 'Consultando Testi Antichi...',
        privacy: 'Il contenuto del tuo sogno viene utilizzato solo per questa analisi e non viene mai memorizzato.',
        summaryEmotion: 'Emozione del Sogno',
        summaryClarity: 'Chiarezza del Sogno',
        summaryTime: 'Ora di Analisi',
        resultTitle: 'La Tua Interpretazione del Sogno',
        timestampLabel: 'Ora di Interpretazione: ',
        dreamCount: '{count} sogni interpretati',
        gate: {
          title: 'Sblocca l\'Interpretazione Completa',
          subtitle: 'Inserisci la tua email per rivelare l\'analisi completa.',
          button: 'Sblocca',
          privacy: 'Rispettiamo la tua privacy. Cancellati quando vuoi.',
          success: 'Interpretazione completa sbloccata!',
          error: 'Per favore inserisci un\'email valida.'
        },
        error: 'Impossibile interpretare al momento. Riprova piu tardi.'
      }
    };

    // Initialize
    this.interpretBtn.addEventListener('click', this.runInterpretation.bind(this));
    this.setupLanguageSelector();
    this.updateDreamCount();
    
    // Update count every 10 minutes
    setInterval(() => this.updateDreamCount(), 10 * 60 * 1000);
  }
  
  delay = ms => new Promise(res => setTimeout(res, ms));

  // Dream Count Methods
  getDreamCount() {
    const now = Date.now();
    let data = null;
    
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      if (stored) {
        data = JSON.parse(stored);
      }
    } catch (e) {
      console.error('Error reading dream count:', e);
    }
    
    if (!data) {
      data = { count: this.BASE_COUNT, lastUpdate: now };
      this.saveDreamCount(data);
      return data.count;
    }
    
    const elapsed = now - data.lastUpdate;
    const intervals = Math.floor(elapsed / (10 * 60 * 1000));
    
    if (intervals > 0) {
      let totalIncrease = 0;
      for (let i = 0; i < intervals; i++) {
        totalIncrease += Math.floor(Math.random() * 8) + 1;
      }
      data.count += totalIncrease;
      data.lastUpdate = now;
      this.saveDreamCount(data);
    }
    
    return data.count;
  }
  
  saveDreamCount(data) {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      console.error('Error saving dream count:', e);
    }
  }
  
  incrementDreamCount() {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      if (stored) {
        const data = JSON.parse(stored);
        data.count += 1;
        this.saveDreamCount(data);
        return data.count;
      }
    } catch (e) {
      console.error('Error incrementing dream count:', e);
    }
    return this.getDreamCount();
  }
  
  updateDreamCount() {
    const count = this.getDreamCount();
    const t = this.uiTranslations[this.currentLang] || this.uiTranslations['English'];
    if (this.countBadge) {
      this.countBadge.textContent = t.dreamCount.replace('{count}', count.toLocaleString());
    }
  }

  // Language Selector & UI Update
  setupLanguageSelector() {
    const langRadios = document.querySelectorAll(`input[name="response-lang-${this.sectionId}"]`);
    
    langRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        this.currentLang = radio.value;
        this.updateAllUIText();
      });
    });
  }

  updateAllUIText() {
    const t = this.uiTranslations[this.currentLang] || this.uiTranslations['English'];
    
    // Language label
    const langLabel = document.getElementById(`lang-label-${this.sectionId}`);
    if (langLabel) langLabel.textContent = t.langLabel;
    
    // Disclaimer
    const disclaimerTitle = document.getElementById(`disclaimer-title-${this.sectionId}`);
    const disclaimerContent = document.getElementById(`disclaimer-content-${this.sectionId}`);
    if (disclaimerTitle) disclaimerTitle.textContent = t.disclaimer.title;
    if (disclaimerContent) disclaimerContent.innerHTML = t.disclaimer.content;
    
    // Input area
    const inputLabel = document.getElementById(`input-label-${this.sectionId}`);
    const inputHint = document.getElementById(`input-hint-${this.sectionId}`);
    if (inputLabel) inputLabel.textContent = t.inputLabel;
    if (inputHint) inputHint.textContent = t.inputHint;
    if (this.dreamInput) this.dreamInput.placeholder = t.inputPlaceholder;
    
    // Emotion options
    const emotionLabel = document.getElementById(`emotion-label-${this.sectionId}`);
    if (emotionLabel) emotionLabel.textContent = t.emotionLabel;
    
    const emotionList = document.getElementById(`emotion-list-${this.sectionId}`);
    if (emotionList) {
      emotionList.querySelectorAll('span[data-key]').forEach(span => {
        const key = span.getAttribute('data-key');
        if (t.emotions[key]) {
          span.textContent = t.emotions[key];
        }
      });
    }
    
    // Clarity options
    const clarityLabel = document.getElementById(`clarity-label-${this.sectionId}`);
    if (clarityLabel) clarityLabel.textContent = t.clarityLabel;
    
    const clarityList = document.getElementById(`clarity-list-${this.sectionId}`);
    if (clarityList) {
      clarityList.querySelectorAll('span[data-key]').forEach(span => {
        const key = span.getAttribute('data-key');
        if (t.clarity[key]) {
          span.textContent = t.clarity[key];
        }
      });
    }
    
    // Button
    if (this.interpretBtn && !this.interpretBtn.disabled) {
      this.interpretBtn.textContent = t.button;
    }
    this.defaultButtonText = t.button;
    
    // Privacy notice
    const privacyNotice = document.getElementById(`privacy-notice-${this.sectionId}`);
    if (privacyNotice) {
      const span = privacyNotice.querySelector('span');
      if (span) span.textContent = t.privacy;
    }
    
    // Summary titles
    const summaryEmotionTitle = document.getElementById(`summary-emotion-title-${this.sectionId}`);
    const summaryClarityTitle = document.getElementById(`summary-clarity-title-${this.sectionId}`);
    const summaryTimeTitle = document.getElementById(`summary-time-title-${this.sectionId}`);
    if (summaryEmotionTitle) summaryEmotionTitle.textContent = t.summaryEmotion;
    if (summaryClarityTitle) summaryClarityTitle.textContent = t.summaryClarity;
    if (summaryTimeTitle) summaryTimeTitle.textContent = t.summaryTime;
    
    // Result title
    const resultTitle = document.getElementById(`ai-result-title-${this.sectionId}`);
    if (resultTitle) resultTitle.textContent = t.resultTitle;
    
    // Timestamp label
    const timestampLabel = document.getElementById(`timestamp-label-${this.sectionId}`);
    if (timestampLabel) timestampLabel.textContent = t.timestampLabel;
    
    // Dream count
    this.updateDreamCount();
  }

  // Markdown Parser
  parseSimpleMarkdown(text) {
    if (!text) return '';
    
    let safeText = text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    
    safeText = safeText.replace(/^##\s*(\d+\.?\s*)?(.*?)$/gm, '<h3>$2</h3>');
    safeText = safeText.replace(/^###\s*(.*?)$/gm, '<h3>$1</h3>');
    safeText = safeText.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    safeText = safeText.replace(/\[\[([^\]]+)\]\]/g, '<span class="pro-term">$1</span>');
    safeText = safeText.replace(/吉兆|大吉|【吉】/g, '<span class="keyword-auspicious">$&</span>');
    safeText = safeText.replace(/凶兆|不吉|【凶】/g, '<span class="keyword-warning">$&</span>');
    safeText = safeText.replace(/\n/g, '<br>');
    safeText = safeText.replace(/(<br>\s*){3,}/g, '<br><br>');
    
    return safeText;
  }

  // Build AI Prompt
  constructPrompt(dreamContent, emotion, clarity, langCode) {
    const t = this.uiTranslations[langCode] || this.uiTranslations['English'];
    const emotionLabel = t.emotions[emotion] || emotion;
    const clarityLabel = t.clarity[clarity] || clarity;
    
    const langInstructions = {
      'English': 'Write in warm, insightful English with a mystical yet accessible tone.',
      'zh-CN': '用温暖、富有洞察力的简体中文撰写，语调神秘却不晦涩。',
      'zh-TW': '用溫暖、富有洞察力的繁體中文撰寫，語調神秘卻不晦澀。',
      'Spanish': 'Escribe en espanol calido y perspicaz con un tono mistico pero accesible.',
      'German': 'Schreiben Sie in warmem, einfuhlsamem Deutsch mit einem mystischen, aber zuganglichen Ton.',
      'French': 'Ecrivez en francais chaleureux et perspicace avec un ton mystique mais accessible.',
      'Italian': 'Scrivi in italiano caloroso e perspicace con un tono mistico ma accessibile.',
      'Dutch': 'Schrijf in warm, inzichtelijk Nederlands met een mystieke maar toegankelijke toon.'
    };
    
    const langInstruction = langInstructions[langCode] || langInstructions['English'];
    
    return `
You are a master dream interpreter combining ancient Zhou Gong wisdom with modern psychological insight.

## USER'S DREAM DATA

Dream Content: ${dreamContent}

Emotion Upon Waking: ${emotionLabel}

Dream Clarity: ${clarityLabel}

## LANGUAGE

Language: ${langCode}
${langInstruction}

## YOUR TASK

Provide a comprehensive dream interpretation with EXACTLY these three sections. Each section MUST be substantial (200-400 words).

## REQUIRED OUTPUT FORMAT

Use this EXACT structure with ## headers:

## 1. Traditional Interpretation (Zhou Gong)

Analyze the dream using traditional Zhou Gong dream interpretation methods:
- Identify 3-5 key symbols/images from the dream
- For each symbol, provide the traditional Zhou Gong meaning
- Give an overall fortune reading
- Include traditional proverbs or sayings when relevant
- Use [[brackets]] for key fortune terms

## 2. Psychological Analysis

Analyze the dream through a modern psychological lens:
- Connect the dream to the user's waking emotion (${emotionLabel})
- Identify potential subconscious stressors, desires, or unresolved issues
- Explain what the dream imagery might symbolize about their inner state
- Consider how the dream clarity (${clarityLabel}) relates to their psychological processing
- Use [[brackets]] for psychological terms

## 3. Spiritual Guidance

Provide exactly 3 specific, actionable recommendations:
1. **Action**: A concrete physical action they can take today or tonight
2. **Affirmation**: A specific positive phrase they should tell themselves
3. **Direction**: Guidance on what to focus on or avoid in the near future

Each recommendation should be 2-3 sentences with clear, practical advice.

## FORMATTING RULES

1. Use ## for main section titles
2. Use **bold** for emphasis
3. Use [[brackets]] for key mystical/psychological terms
4. NO emojis
5. NO horizontal lines
6. Write in the user's selected language: ${langCode}
7. Be warm, insightful, and genuinely helpful
8. Total length should be 800-1200 words
`.trim();
  }

  // Render result with email gate at blur start
  renderResultWithGate(fullContent) {
    const t = this.uiTranslations[this.currentLang] || this.uiTranslations['English'];
    
    // Find split point (around 50%)
    const splitPoint = Math.floor(fullContent.length * 0.5);
    let breakPoint = fullContent.indexOf('<br>', splitPoint);
    if (breakPoint === -1) breakPoint = fullContent.indexOf('</h3>', splitPoint);
    if (breakPoint === -1) breakPoint = splitPoint;
    
    const visiblePart = fullContent.substring(0, breakPoint);
    const hiddenPart = fullContent.substring(breakPoint);
    
    // Build HTML with gate card between visible and blurred content
    this.aiContent.innerHTML = `
      <div class="visible-content">${visiblePart}</div>
      
      <div class="email-gate-overlay" id="email-gate-overlay-${this.sectionId}">
        <div class="email-gate-card" id="email-gate-card-${this.sectionId}">
          <div class="gate-seal">
            <span>鑰</span>
          </div>
          <h4 class="gate-title">${t.gate.title}</h4>
          <p class="gate-subtitle">${t.gate.subtitle}</p>
          <div class="gate-input-group">
            <input type="email" id="gate-email-${this.sectionId}" class="gate-input" placeholder="your@email.com" required>
            <button id="unlock-btn-${this.sectionId}" class="gate-btn">${t.gate.button}</button>
          </div>
          <p class="gate-privacy">${t.gate.privacy}</p>
          <p id="gate-msg-${this.sectionId}" class="gate-msg"></p>
        </div>
        
        <div class="content-blurred" id="hidden-content-${this.sectionId}">${hiddenPart}</div>
      </div>
    `;
    
    // Setup unlock button
    this.setupUnlockButton();
  }

  setupUnlockButton() {
    const unlockBtn = document.getElementById(`unlock-btn-${this.sectionId}`);
    const emailInput = document.getElementById(`gate-email-${this.sectionId}`);
    const gateMsg = document.getElementById(`gate-msg-${this.sectionId}`);
    const t = this.uiTranslations[this.currentLang] || this.uiTranslations['English'];
    
    if (!unlockBtn) return;
    
    unlockBtn.addEventListener('click', async () => {
      const email = emailInput.value.trim();
      
      if (!email || !email.includes('@')) {
        gateMsg.textContent = t.gate.error;
        gateMsg.style.color = '#dc3545';
        return;
      }
      
      unlockBtn.textContent = '...';
      unlockBtn.disabled = true;
      
      // Submit to Shopify
      const formData = new FormData();
      formData.append('form_type', 'customer');
      formData.append('utf8', '✓');
      formData.append('contact[email]', email);
      formData.append('contact[tags]', 'newsletter, dream_interpretation_unlock');
      
      try {
        await fetch('/contact', { method: 'POST', body: formData });
        
        // Unlock content
        const hiddenContent = document.getElementById(`hidden-content-${this.sectionId}`);
        const gateCard = document.getElementById(`email-gate-card-${this.sectionId}`);
        
        if (hiddenContent) {
          hiddenContent.classList.remove('content-blurred');
          hiddenContent.classList.add('content-unlocked');
        }
        
        if (gateCard) {
          gateCard.classList.add('gate-hidden');
        }
        
        gateMsg.textContent = t.gate.success;
        gateMsg.style.color = '#28a745';
        
      } catch (e) {
        console.error('Email submission error:', e);
        // Still unlock on error
        const hiddenContent = document.getElementById(`hidden-content-${this.sectionId}`);
        const gateCard = document.getElementById(`email-gate-card-${this.sectionId}`);
        if (hiddenContent) {
          hiddenContent.classList.remove('content-blurred');
          hiddenContent.classList.add('content-unlocked');
        }
        if (gateCard) gateCard.classList.add('gate-hidden');
      }
    });
  }

  // Main Interpretation
  async runInterpretation() {
    const dreamContent = this.dreamInput.value.trim();
    const t = this.uiTranslations[this.currentLang] || this.uiTranslations['English'];
    
    if (!dreamContent) {
      alert(this.currentLang.startsWith('zh') ? '请先描述您的梦境。' : 'Please describe your dream first.');
      return;
    }

    // Get selected options
    const emotionRadio = document.querySelector(`input[name="dream-emotion-${this.sectionId}"]:checked`);
    const clarityRadio = document.querySelector(`input[name="dream-clarity-${this.sectionId}"]:checked`);
    
    const selectedEmotion = emotionRadio ? emotionRadio.value : 'calm';
    const selectedClarity = clarityRadio ? clarityRadio.value : 'blurry';

    const now = new Date();
    
    // Update timestamp
    if (this.timestampEl) {
      this.timestampEl.textContent = now.toLocaleString(undefined, {
        year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
      });
    }

    // Update summary with localized text
    document.getElementById(`summary-emotion-${this.sectionId}`).textContent = t.emotions[selectedEmotion] || selectedEmotion;
    document.getElementById(`summary-clarity-${this.sectionId}`).textContent = t.clarity[selectedClarity] || selectedClarity;
    document.getElementById(`summary-time-${this.sectionId}`).textContent = now.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

    // Disable button and show loading
    this.interpretBtn.disabled = true;
    this.interpretBtn.textContent = t.buttonLoading;
    this.resultContainer.style.display = 'block';
    
    // Reset AI content to loading state
    this.aiContent.innerHTML = `
      <div class="loader"></div>
      <p class="ai-loading-text">${t.buttonLoading}</p>
    `;

    // Scroll to results
    setTimeout(() => {
      const yOffset = -60;
      const elementPosition = this.resultContainer.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY + yOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }, 100);

    try {
      const prompt = this.constructPrompt(dreamContent, selectedEmotion, selectedClarity, this.currentLang);
      
      const response = await fetch(this.aiServerUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: prompt })
      });
      
      if (!response.ok) throw new Error(`Server Error: ${response.status}`);
      const result = await response.json();
      
      const formattedHtml = this.parseSimpleMarkdown(result.response);
      
      // Render with email gate
      this.renderResultWithGate(formattedHtml);
      
      // Increment dream count
      this.incrementDreamCount();
      this.updateDreamCount();

    } catch (error) {
      console.error(error);
      this.aiContent.innerHTML = `<p style="color:#dc3545;text-align:center;">${t.error}<br>(${error.message})</p>`;
    } finally {
      this.resetUI();
    }
  }

  resetUI() {
    const t = this.uiTranslations[this.currentLang] || this.uiTranslations['English'];
    this.interpretBtn.disabled = false;
    this.interpretBtn.textContent = t.button;
  }
}

const initDreamSections = () => {
  document.querySelectorAll('.dream-app-container').forEach(container => {
    if (!container.dataset.initialized) {
      new DreamInterpreter(container);
      container.dataset.initialized = true;
    }
  });
};

document.addEventListener('DOMContentLoaded', initDreamSections);
document.addEventListener('shopify:section:load', initDreamSections);

  } catch(e) { console.error(e); }
})();
})();
